import React, { useState, useEffect, useContext, useRef } from "react";
import { UserInformationContext, C4FStatusContext, InfoModalContext, SitterUserInformationContext, AdminUserInformationContext, ReferenceDataContext } from "../main/App";
import { LocalizationContext } from "../main/LocalizationContext";
import { DropdownButton, ButtonGroup, Dropdown, Button, Form, Row, Container, Col, Table, Alert, InputGroup } from 'react-bootstrap';
import Weather from './Weather';
import C4FChat from "../common/C4FChat";
import { getJersey } from "./C4FLeaderJerseys";
import C4FDetailedProfile from "../calendar/C4FDetailedProfile";
import C4FSimpleTable from "../common/C4FSimpleTable";
import config from "../etc/config.json";
import { Stage, Layer, Line, Rect } from 'react-konva';
import '../css/Race.css';
import moment from 'moment-timezone';
import Countdown from 'react-countdown';
import CalendarModal from "../calendar/CalendarModal";
import WeatherForecastModal from "./WeatherForecastModal";
import ReplayModal from "./ReplayModal";
import RaceFinancesModal from "./RaceFinancesModal";
import SkillClimbing from "../img/icons/skill-climbing.png";
import SkillFlat from "../img/icons/skill-flat.png";
import SkillDownhill from "../img/icons/skill-downhill.png";
import SkillTimeTrial from "../img/icons/skill-timetrial.png";
import SkillSprint from "../img/icons/skill-sprint.png";
import SkillCobbles from "../img/icons/skill-cobbles.png";
import SkillRegeneration from "../img/icons/skill-regeneration.png";
import { currentISODate, RiderImage, getUnicodeOrImageFlag, getUnicodeFlag, getRandomIntFromInterval, popNthElement, getPreviousElementOfArray, getNextElementOfArray, formatTimeSeconds, getJerseyForRacer, getC4FCodeForCountryCode, hasNationalTeam, getNationalTeam, getRegularTeam, getTimeSinceServertime, isNationalTeamRace } from "../common/Helpers";
import Road from "./Road";

function Race(props) {

  const { userInformation } = useContext(UserInformationContext);
  const { getLocalizedText } = useContext(LocalizationContext);
  const { sitterUserInformation } = useContext(SitterUserInformationContext);
  const { adminUserInformation } = useContext(AdminUserInformationContext);
  const { raiseError, handleBackendRequest, browserInfo } = useContext(C4FStatusContext);
  const { showRiderInfo, showTeamInfo } = useContext(InfoModalContext);
  const { countries } = useContext(ReferenceDataContext);
  const mounted = useRef(false);
  const [controlledTeam, setControlledTeam] = useState(null);
  const [autoRefreshTimer, doResetAutoRefreshTimer] = useState(0);
  const [refreshEnabled, setRefreshEnabled] = useState(true);
  const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(false);
  const [responseStatus, setResponseStatus] = useState('ok');
  const [chatRefresh, doChatRefresh] = useState(0);
  const [lastRefresh, setLastRefresh] = useState(moment());
  const [profile, setProfile] = useState(null);
  const [weatherForecast, setWeatherForecast] = useState([]);
  const [raceEdition, setRaceEdition] = useState(null);
  const [groupsWithPositions, setGroupsWithPositions] = useState(null);
  const [groupDisplayScale, setGroupDisplayScale] = useState(60);
  const [tab, setTab] = useState("race");
  const [tempoSettings, setTempoSettings] = useState(null);
  const [sprintGroup, setSprintGroup] = useState(0);
  const [voting, setVoting] = useState([]);
  const [mostActiveRiderVote, setMostActiveRiderVote] = useState(0);
  const [votingInfo, setVotingInfo] = useState('');
  const [racerTeamSortBy, setRacerTeamSortBy] = useState('time');
  const [racerTeamSortOrder, setRacerTeamSortOrder] = useState('asc');
  const [GCSortBy, setGCSortBy] = useState('gc');
  const [GCSortOrder, setGCSortOrder] = useState('desc');
  const [showCalendarRaceId, setShowCalendarRaceId] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const handleCloseCalendar = () => setShowCalendar(false);
  const [showWeatherForecast, setShowWeatherForecast] = useState(false);
  const handleCloseWeatherForecast = () => setShowWeatherForecast(false);
  const [showReplay, setShowReplay] = useState(false);
  const handleCloseReplay = () => setShowReplay(false);
  const [showFinances, setShowFinances] = useState(false);
  const handleCloseFinances = () => setShowFinances(false);
  const [interviews, setInterviews] = useState([]);
  const [userInterview, setUserInterview] = useState(null);
  const [userInterviewRequest, setUserInterviewRequest] = useState('None');
  const [userInterviewAnswer1, setUserInterviewAnswer1] = useState('');
  const [userInterviewAnswer2, setUserInterviewAnswer2] = useState('');
  const [userInterviewAnswer3, setUserInterviewAnswer3] = useState('');
  const [userInterviewInfo, setUserInterviewInfo] = useState('');
  const sprintRef = useRef();
  const scrollRight = () => sprintRef.current?.scrollTo(100000, 0);
  const [editRacerTactic, setEditRacerTactic] = useState(null);
  const [selectedGroupIndex, setSelectedGroupIndex] = useState(0);
  const [selectedRacer, setSelectedRacer] = useState(null);

  const groupDisplaySizes = [30, 40, 50, 60, 70, 80];

  function initVoting(teams) {
    let voting = [];
    teams.slice()
      .filter(racerTeam => racerTeam.team.teamName !== controlledTeam)
      .map(racerTeam => {
        voting.push({
          racerTeamId: racerTeam.id,
          teamName: racerTeam.team.teamName,
          vote: -10,
          message: ''
        })
      });
    setVoting(voting);
  }

  function handleVoting(racerTeam, type, value) {
    let votingLocal = [];

    voting.map(vote => {
      votingLocal.push(
        (vote.racerTeamId === racerTeam.id) ?
          {
            ...vote,
            vote: (type === 'vote') ? value : vote.vote,
            message: (type === 'message') ? value : vote.message.substring(0, 100)
          } : vote)
    })
    setVoting(votingLocal);
  }

  function handleInterviews() {
    if (userInterviewRequest === 'None')
      updateInterviews();
    setTab('interviews');
  }

  function setTabSprint() {
    if (raceEdition != null) {
      if (raceEdition.sprintStatus !== 'NotStarted' && raceEdition.sprintStatus !== 'Completed') {
        setTab('sprint');
      }
    }
  }

  function handleRequestFailed() {
    setResponseStatus('failed');
  }
  function handleVotingResponse() {
    setResponseStatus('ok');
    setVotingInfo('Votes submitted');
    updateRace(false);
  }

  function handleSubmitVoting() {
    let votesWithoutMessage = voting.filter(vote => vote.vote > -5 && vote.message.length === 0);
    if (typeof votesWithoutMessage !== 'undefined' && votesWithoutMessage.length > 0) {
      raiseError('Voting failed', 0, 'Please provide a message with every vote!');
      return;
    }

    let messagesWithoutVote = voting.filter(vote => vote.vote < -5 && vote.message.length > 0);
    if (typeof messagesWithoutVote !== 'undefined' && messagesWithoutVote.length > 0) {
      raiseError('Voting failed', 0, 'Please provide a vote with every message!');
      return;
    }

    setResponseStatus('pending');
    handleBackendRequest('POST',
      '/raceEdition/' + raceEdition.id + '/team/' + controlledTeam + '/vote',
      voting.filter(vote => vote.vote > -5),
      { mostActiveRider: (mostActiveRiderVote !== 0) ? mostActiveRiderVote : '' },
      handleVotingResponse, false, handleRequestFailed);
  }

  function handleShowFromTeamInfo(fairplayRecord) {
    showTeamInfo({ teamId: fairplayRecord.fromTeamId, teamName: fairplayRecord.fromTeam });
  }
  function handleShowToTeamInfo(fairplayRecord) {
    showTeamInfo({ teamId: fairplayRecord.toTeamId, teamName: fairplayRecord.toTeam });
  }

  function handleShowCalendar(raceId) {
    if (mounted.current) {
      setShowCalendarRaceId(raceId);
      setShowCalendar(true);
    }
  };

  function handleShowWeatherForecast() {
    if (mounted.current) {
      setShowWeatherForecast(true);
    }
  };

  function handleShowReplay() {
    if (mounted.current) {
      setShowReplay(true);
    }
  };

  function handleShowFinances() {
    if (mounted.current) {
      setShowFinances(true);
    }
  };

  function handleRacerTeamSorting(sortBy) {
    let sortByChange = racerTeamSortBy !== sortBy;
    setRacerTeamSortBy(sortBy);
    setRacerTeamSortOrder((sortByChange) ? 'desc' : (racerTeamSortOrder === 'asc') ? 'desc' : 'asc');
  }

  function handleGCSorting(sortBy, tabChosen) {
    let sortByChange = GCSortBy !== sortBy;
    setGCSortBy(sortBy);
    // for GC sort ascending first, for points classifications sort descending first (when switching)
    setGCSortOrder(sortByChange ? 
      (sortBy === 'gc' ? 'asc' : 'desc') 
      : 
      (GCSortOrder === 'asc' ? 'desc' : 'asc'));

    if (sortBy === 'gc' && tabChosen !== 'young') {
      setTab('gc')
    }
    else if (sortBy === 'gc' && tabChosen === 'young') {
      setTab('young')
    }
    else 
      setTab(tabChosen);
  }

  function findAgeLimit(tabChosen) {
    if (tabChosen === 'young') {
      return 24;
    }
    else {
      return 50;
    }
  }

  function updateGroupsWithPositions(raceEdition) {
    let groups = [];

    // create one group for each gap
    raceEdition.groups[0].racers.forEach(racer => {
      // find group with same gap and add
      if (groups.some(g => g.gap === racer.gapCurrentStage)) {
        groups.find(g => g.gap === racer.gapCurrentStage).racers.push(racer);
      }
      else {
        groups.push({
          gap: racer.gapCurrentStage,
          racers: [racer]
        });
      }
    })

    // sort riders in group by tempo and racer number
    groups.forEach(group => group.racers.sort(function (a, b) {
      return b.tempoSuccess.localeCompare(a.tempoSuccess) || a.number - b.number
    }));

    // random position for first rider in tempo

    let groupsWithPositionsLocal = []
    groups.forEach(group => groupsWithPositionsLocal.push(updateGroupWithPositions(group)));


    setGroupsWithPositions(groupsWithPositionsLocal)
  }

  function updateGroupWithPositions(group) {
    let currentX = 0;
    let currentY = getRandomIntFromInterval(3, 3);
    let remainingY = [1, 2, 3, 4, 5];
    let racersUpdated = [];
    group.racers.forEach(racer => {
      racersUpdated.push({
        ...racer,
        position: {
          x: currentX,
          y: racer.tempoSuccess === 'None' ? popNthElement(remainingY, 0) : currentY,
        },
        selectionMode: isOwnRacer(racer) ? 'OwnRiderNoSelection' : 'OtherRiderNoSelection'
      });
      // if in tempo x++
      if (racer.tempoSuccess !== 'None') currentX++;
      if (racer.tempoSuccess === 'None' && remainingY.length === 0) {
        currentX++;
        remainingY = [1, 2, 3, 4, 5];
      }

    })
    return {
      gap: group.gap,
      racers: racersUpdated
    };
  }

  function handleSetTempoResponse(response) {
    setResponseStatus('ok');
    let allRacersLocal = [];
    for (const racer of raceEdition.groups[0].racers) {
      if (racer.id !== response.id) {
        allRacersLocal.push(racer);
      }
      else {
        let returnedRacer = response;
        // keep positions in race and in sprint, as the race might have progressed 
        // meanwhile and racer would be shown in weird places
        // a race refresh will take care of that
        returnedRacer.group = racer.group;
        returnedRacer.gapCurrentStage = racer.gapCurrentStage;
        returnedRacer.positionX = racer.positionX;
        returnedRacer.positionY = racer.positionY;
        returnedRacer.racerTeamName = racer.racerTeamName;
        allRacersLocal.push(returnedRacer);
      }
    }
    let raceEditionLocal = raceEdition;
    raceEditionLocal.groups[0].racers = allRacersLocal;
    setRaceEdition(raceEditionLocal);
    updateGroupsWithPositions(raceEditionLocal);
    updateTempoSettings(raceEditionLocal, controlledTeam);
    setEditRacerTactic(null);
  }

  function setTempoITT(racer, tempoIntensity, risk) {
    setResponseStatus('pending');
    handleBackendRequest('POST',
      '/raceEdition/' + raceEdition.id + '/racer/' + racer.id + '/setTempoITT',
      {},
      {
        tempoIntensity: tempoIntensity,
        risk: risk,
        updateOnlineStatus: raceEdition.sprintStatus !== 'Completed',
        userId: userInformation.userID,
        controllingUserId: sitterUserInformation || adminUserInformation ? 
          (sitterUserInformation ? sitterUserInformation.userID : adminUserInformation.userID) : userInformation.userID
      },
      handleSetTempoResponse, false, handleRequestFailed, true);

  }

  function setTempoTTT(racer, tempoShare, waitForRider, effort) {
    setResponseStatus('pending');

    // session expires is also suppressed ...
    handleBackendRequest('POST',
      '/raceEdition/' + raceEdition.id + '/racer/' + racer.id + '/setTempoTTT',
      {},
      {
        tempoShare: tempoShare,
        waitForRider: waitForRider,
        effort: effort,
        updateOnlineStatus: raceEdition.sprintStatus !== 'Completed',
        userId: userInformation.userID,
        controllingUserId: sitterUserInformation || adminUserInformation ? 
          (sitterUserInformation ? sitterUserInformation.userID : adminUserInformation.userID) : userInformation.userID
      },
      handleSetTempoResponse, false, handleRequestFailed, true);

  }

  function setTempo(racer, tempoStrategy, tempoAction, tempoUntil) {
    handleTempoOptions(racer, tempoStrategy, racer.tempoIntensity, tempoAction, tempoUntil, racer.endurance, racer.tempoStartAt,
      racer.tempoStopAt, racer.attackAt, racer.helpsRacer, racer.followsRacer);
  }
  function setIntensity(racer, tempoIntensity) {
    handleTempoOptions(racer, racer.tempoStrategy, tempoIntensity, racer.tempoAction, racer.tempoUntil, racer.endurance, racer.tempoStartAt,
      racer.tempoStopAt, racer.attackAt, racer.helpsRacer, racer.followsRacer);
  }
  function setEndurance(racer, endurance) {
    handleTempoOptions(racer, racer.tempoStrategy, racer.tempoIntensity, racer.tempoAction, racer.tempoUntil, endurance, racer.tempoStartAt,
      racer.tempoStopAt, racer.attackAt, racer.helpsRacer, racer.followsRacer);
  }
  function helpRacer(racer, helpsRacer) {
    handleTempoOptions(racer, racer.tempoStrategy, racer.tempoIntensity, racer.tempoAction, racer.tempoUntil, racer.endurance, racer.tempoStartAt,
      racer.tempoStopAt, racer.attackAt, helpsRacer, racer.followsRacer);
  }
  function followRacer(racer, followsRacer) {
    handleTempoOptions(racer, racer.tempoStrategy, racer.tempoIntensity, racer.tempoAction, racer.tempoUntil, racer.endurance, racer.tempoStartAt,
      racer.tempoStopAt, racer.attackAt, racer.helpsRacer, followsRacer);
  }
  function clearHelpAndFollow(racer) {
    handleTempoOptions(racer, racer.tempoStrategy, racer.tempoIntensity, racer.tempoAction, racer.tempoUntil, racer.endurance, racer.tempoStartAt,
      racer.tempoStopAt, racer.attackAt, 0, 0);
  }
  function tempoStartAt(racer, tempoStartAt) {
    handleTempoOptions(racer, racer.tempoStrategy, racer.tempoIntensity, racer.tempoAction, racer.tempoUntil, racer.endurance, tempoStartAt,
      racer.tempoStopAt, racer.attackAt, racer.helpsRacer, racer.followsRacer);
  }
  function tempoStopAt(racer, tempoStopAt) {
    handleTempoOptions(racer, racer.tempoStrategy, racer.tempoIntensity, racer.tempoAction, racer.tempoUntil, racer.endurance, racer.tempoStartAt,
      tempoStopAt, racer.attackAt, racer.helpsRacer, racer.followsRacer);
  }
  function attackAt(racer, attackAt) {
    handleTempoOptions(racer, racer.tempoStrategy, racer.tempoIntensity, racer.tempoAction, racer.tempoUntil, racer.endurance, racer.tempoStartAt,
      racer.tempoStopAt, attackAt, racer.helpsRacer, racer.followsRacer);
  }
  function handleTempoOptions(racer, tempoStrategy, tempoIntensity, tempoAction, tempoUntil, endurance, tempoStartAt, tempoStopAt, attackAt, helpsRacer, followsRacer) {
    setResponseStatus('pending');

    handleBackendRequest('POST',
      '/raceEdition/' + raceEdition.id + '/racer/' + racer.id + '/setTempo',
      {},
      {
        tempoStrategy: tempoStrategy,
        tempoIntensity: tempoIntensity,
        tempoAction: tempoAction,
        tempoUntil: tempoUntil,
        endurance: endurance,
        tempoStartAt: tempoStartAt,
        tempoStopAt: tempoStopAt,
        attackAt: attackAt,
        helpsRacer: helpsRacer,
        followsRacer: followsRacer,
        updateOnlineStatus: raceEdition.sprintStatus !== 'Completed',
        userId: userInformation.userID,
        controllingUserId: sitterUserInformation || adminUserInformation ? 
          (sitterUserInformation ? sitterUserInformation.userID : adminUserInformation.userID) : userInformation.userID
      },
      handleSetTempoResponse, false, handleRequestFailed, true);
  }

  function setSprint(racer, sprintStrategy) {
    setResponseStatus('pending');
    handleBackendRequest('POST',
      '/raceEdition/' + raceEdition.id + '/racer/' + racer.id + '/setSprint',
      {},
      {
        sprintStrategy: sprintStrategy,
        updateOnlineStatus: raceEdition.sprintStatus !== 'Completed',
        userId: userInformation.userID,
        controllingUserId: sitterUserInformation || adminUserInformation ? 
          (sitterUserInformation ? sitterUserInformation.userID : adminUserInformation.userID) : userInformation.userID
      },
      handleSetTempoResponse, false, handleRequestFailed, true);
  }

  function setOnlineStatus(onlineStatus) {
    handleBackendRequest('POST',
      '/raceEdition/' + raceEdition.id + '/setOnline',
      {},
      {
        raceEditionId: raceEdition.id,
        userId: userInformation.userID,
        controllingUserId: sitterUserInformation || adminUserInformation ? 
          (sitterUserInformation ? sitterUserInformation.userID : adminUserInformation.userID) : userInformation.userID,
        onlineStatus: onlineStatus,
        role: props.userRole === 'Participant' ? 'Participant' : 'Visitor'
      });
  }

  function getRacerNameAndJersey(racer) {
    return <>
      {racer.rider.firstNames + '\xa0' + racer.rider.lastNames}
      {(racer.raceJersey !== 'None') ?
          <img alt={racer.raceJersey} title={racer.raceJersey} 
            src={getJersey('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName, racer.raceJersey)} 
            style={{ maxHeight: "18px" }} />
        :
        racer.rider.jerseys.map(jersey => (
          <img alt={jersey} title={jersey} 
            src={getJersey('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName, jersey)} 
            style={{ maxHeight: "18px" }} />
        ))}
    </>
  }

  function getRiderFullName(racerId) {
    let racer = raceEdition.groups[0].racers.find(racer => racer.id === racerId);
    return (racer === null || typeof racer === 'undefined') ? 'None' : racer.number + ' ' + racer.rider.firstNames + ' ' + racer.rider.lastNames + ' (' + racer.racerTeamName + ')';
  }

  function getRiderName(racerId) {
    let racer = raceEdition.groups[0].racers.find(racer => racer.id === racerId);
    return (racer === null || typeof racer === 'undefined') ? 'None' : racer.number + ' ' + racer.rider.firstNames.charAt(0) + '. ' + racer.rider.lastNames.substring(0, 8);
  }

  function getRiderNameSprint(racerId) {
    let racer = raceEdition.groups[0].racers.find(racer => racer.id === racerId);
    return (racer === null || typeof racer === 'undefined') ? 'None' : racer.rider.skills.Sprint + ' ' + racer.rider.lastNames.substring(0, 8);
  }

  function getRiderNumberOnly(racerId) {
    let racer = raceEdition.groups[0].racers.find(racer => racer.id === racerId);
    return (racer === null || typeof racer === 'undefined') ? '-' : racer.number;
  }

  function handleAutoRefresh() {
    doResetAutoRefreshTimer(prev => prev + 1);
    updateRace(true);
    // setTimeout(() => scrollSprintRight(), 500);
  }

  function handleRefresh() {
    setRefreshEnabled(false);
    doResetAutoRefreshTimer(prev => prev + 1);
    updateRace(false);
    handleRacerTeamSorting('time');
    // setTimeout(() => scrollSprintRight(), 500);
  }

  function getBackgroundColor(TourName) {
    return "rgba(222, 233, 244, 1)";
  }

  function updateTempoSettings(raceEdition, controlledTeam) {
    let tempoSettings = [];
    raceEdition.groups[0].racers.slice()
      .filter(racer => racer.racerTeamName === controlledTeam)
      .map((racer) => {
        tempoSettings.push({ riderId: racer.rider.id, tempoStartAt: racer.tempoStartAt, tempoStopAt: racer.tempoStopAt, attackAt: racer.attackAt })
      });
    setTempoSettings(tempoSettings);

  }

  function enrichRacerGroups(raceEdition) {
    let groups = raceEdition.groups.map(g => {
      g.racers = g.racers.map(r => ({
        ...r,
        racerTeamName: getRacerTeamName(r, raceEdition.teams)
      }));
      return g;
    })
    return groups;
  }

  function handleRaceResponse(raceResponse) {
    setResponseStatus('ok');

    // add team name to each racer for performance
    raceResponse.groups = enrichRacerGroups(raceResponse);    

    setRaceEdition(raceResponse);
    // find the team controlled by the user
    let controlledTeam = null;
    if (isNationalTeamRace(raceResponse.race.eventType) && hasNationalTeam(userInformation))
      controlledTeam = getNationalTeam(userInformation).teamName;
    else
      controlledTeam = getRegularTeam(userInformation).teamName;
    setControlledTeam(controlledTeam);

    // add positions within a group (as long as it's not done on the server)
    updateGroupsWithPositions(raceResponse);
    // populate tempo setting
    updateTempoSettings(raceResponse, controlledTeam);

    // refresh chat
    doChatRefresh(prev => prev + 1);
    setLastRefresh(moment());

    let currentStage = raceResponse.race.stages[0];
    // skip for rest day
    if (profile === null && currentStage.raceType !== 'RestDay') {
      handleBackendRequest('GET', '/profile/' + currentStage.profile, null, null, setProfile);
      handleBackendRequest('GET', '/profile/' + currentStage.profile + '/weatherForecast', null, null, setWeatherForecast);
    }
    if (voting.length === 0) initVoting(raceResponse.teams);
    let userRacerTeam = raceResponse.teams.find(racerTeam => racerTeam.team.teamName === controlledTeam);

    // prepare interviews
    if (userRacerTeam && userRacerTeam.interviewRequest !== 'None') {
      setUserInterview(userRacerTeam.interview);
      setUserInterviewRequest(userRacerTeam.interviewRequest);
      handleInterviews();
    }
    else {
      setUserInterview(null);
      setUserInterviewRequest('None');
    }

    // disable autorefresh after the end of the race
    if (raceResponse.sprintStatus === 'Completed')
      setAutoRefreshEnabled(false);

    if (raceResponse.sprintStatus !== 'NotStarted' && raceResponse.sprintStatus !== 'Completed')
      scrollRight();
  }


  function updateRace(autoRefresh) {
    setResponseStatus('pending');
    handleBackendRequest('GET', '/raceEdition/' + props.raceEditionId, null, 
      { 
        team: props.userName,
        userId: userInformation.userID,
        updateOnlineStatus: !raceEdition || raceEdition.sprintStatus !== 'Completed',
        controllingUserId: sitterUserInformation || adminUserInformation ? 
          (sitterUserInformation ? sitterUserInformation.userID : adminUserInformation.userID) : userInformation.userID,
        onlineStatus: autoRefresh ? 'Passive' : 'Active'
      }, 
      handleRaceResponse, true, handleRequestFailed, true);

    setTabSprint();
  }

  function handleSaveInterviewResponse() {
    setResponseStatus('ok');
    setUserInterview(null);
    setUserInterviewRequest('None');
    setUserInterviewAnswer1('');
    setUserInterviewAnswer2('');
    setUserInterviewAnswer3('');
    setUserInterviewInfo('Interview saved');
    updateInterviews();
  }
  function saveInterview(skip) {
    setResponseStatus('pending');
    handleBackendRequest('POST',
      '/raceEdition/' + props.raceEditionId + '/team/' + controlledTeam + '/interview',
      {
        type: userInterviewRequest,
        items: [
          {
            question: userInterview.items[0].question,
            answer: (skip) ? '' : userInterviewAnswer1
          },
          {
            question: userInterview.items[1].question,
            answer: (skip) ? '' : userInterviewAnswer2
          },
          {
            question: userInterview.items[2].question,
            answer: (skip) ? '' : userInterviewAnswer3
          }
        ]
      },
      null, handleSaveInterviewResponse, false, handleRequestFailed);
  }

  function updateInterviews() {
    handleBackendRequest('GET', '/raceEdition/' + props.raceEditionId + '/interview', null, null, setInterviews);
  }

  // function scrollSprintRight() {
  //     sprintRef.current.scrollTo(30000, 0);
  // }

  function translateRaceLog(raceLog) {
    const raceLogEntries = [
      { text: 'Steigung', id: 'RaceLogIncline' },
      { text: 'Bergwertung', id: 'RaceLogMountain' },
      { text: 'Kategorie', id: 'RaceLogCategory' },
      { text: 'Sprintwertung', id: 'RaceLogPoints' },
      { text: 'Kopfsteinpflaster', id: 'RaceLogCobbles' },
      { text: 'attackiert', id: 'RaceLogAttack' },
      { text: 'geht mit', id: 'RaceLogFollow' },
      { text: 'schafft es nicht mitzugehen', id: 'RaceLogFailedFollow' },
      { text: 'Gruppe kommt nicht weg', id: 'RaceLogAttackGroupFailed' },
      { text: 'schafft es nicht auszureissen', id: 'RaceLogAttackFailed' },
      { text: 'schafft es nicht an die Spitze', id: 'RaceLogTempoFailed' },
      { text: 'laesst sich zurueckfallen', id: 'RaceLogFallback' },
      { text: 'kann nicht mithalten', id: 'RaceLogDrop' },
      { text: 'wird durchgereicht', id: 'RaceLogDropFurther' },
      { text: 'gibt auf', id: 'RaceLogAbandon' },
      { text: 'sprintet von vorne', id: 'RaceLogSprint' },
      { text: 'geht ans Hinterrad', id: 'RaceLogSprintFollow' },
      { text: 'und wird blockiert', id: 'RaceLogSprintBlock' },
      { text: 'findet kein Hinterrad', id: 'RaceLogSprintNotFollowing' }
    ];

    let translatedRaceLog = raceLog;
    raceLogEntries.map(entry => translatedRaceLog = translatedRaceLog.replaceAll(entry.text, getLocalizedText('race', entry.id)));
    return translatedRaceLog;
  }

  const isOwnRacer = (racer) => racer.racerTeamName === controlledTeam;

  function getRacerTeamName(racer, racerTeams) {
    let racerTeam = racerTeams.find(rt => rt.id === racer.racerTeamId);
    return racerTeam.team.teamName;
  }

  function getSelectionModeForRacer(action, affectedRacer, racer) {
    if (action === 'selectRacer') {
      if (affectedRacer.id === racer.id) return 'OwnRiderSelected';
      else if (isOwnRacer(racer)) {
        if (affectedRacer.helpsRacer === racer.id) return 'OwnRiderHelpedSelectable'
        else return 'OwnRiderSelectable';
      }
      else {
        if (affectedRacer.followsRacer === racer.id) return 'OtherRiderFollowedSelectable'
        else return 'OtherRiderSelectable';
      }
    }
    else if (action === 'unselectRacer') {
      if (isOwnRacer(racer)) return 'OwnRiderNoSelection';
      else return 'OtherRiderNoSelection';
    }
  }

  function handleSelectRacer(selectedRacer) {
    let groupsWithPositionsLocal = groupsWithPositions;
    groupsWithPositionsLocal = groupsWithPositionsLocal.map(group => ({
      gap: group.gap,
      racers: group.racers.map(racer => ({
        ...racer,
        selectionMode: getSelectionModeForRacer('selectRacer', selectedRacer, racer)
      }))
    }));

    // update groupsWithPositions
    setGroupsWithPositions(groupsWithPositionsLocal);
    // set racer for editing
    setSelectedRacer(selectedRacer);
  }

  function handleUnselectRacer(unselectedRacer) {
    let groupsWithPositionsLocal = groupsWithPositions;
    groupsWithPositionsLocal = groupsWithPositionsLocal.map(group => ({
      gap: group.gap,
      racers: group.racers.map(racer => ({
        ...racer,
        selectionMode: getSelectionModeForRacer('unselectRacer', unselectedRacer, racer)
      }))
    }));

    // update groupsWithPositions
    setGroupsWithPositions(groupsWithPositionsLocal);
    // set racer for editing
    setSelectedRacer(null);
  }

  function handleSelectTarget(racer) {
    // own racer -> set helping
    if (isOwnRacer(racer))
      helpRacer(selectedRacer, racer.id)
    // other racer -> set following
    else
      followRacer(selectedRacer, racer.id)

    // unselect all
    handleUnselectRacer(selectedRacer);
  }

  useEffect(() => {
    mounted.current = true;
  }, []);

  useEffect(() => {
    return () => {
      mounted.current = false;
    }
  }, []);

  useEffect(() => {
    if (tab === 'sprint') scrollRight();
  }, [tab]);

  useEffect(() => {
    //get race
    updateRace(false);
  }, []);

  function getRaceTabType() {
    let raceType = raceEdition.race.stages[0].raceType;
    let isCompleted = raceType === 'RestDay' || raceEdition.sprintStatus === 'Completed' || raceEdition.halfStageWaitingTime > 3;
    
    if (isCompleted) return 'Completed';
    else return 'Ongoing' + raceType;
  }

  function getTeamByRacerTeamId(racerTeamId) {
    return raceEdition.teams.some(t => t.id === racerTeamId) ?
      raceEdition.teams.find(t => t.id === racerTeamId).team : null;
  }

  function getFlexibleRefreshDelay() {
    if (props.userRole === 'Participant')
      return userInformation.refreshDelay;
    else {
      if (raceEdition.numberOfParticipants < 15)
        return userInformation.refreshDelay;
      else if (raceEdition.numberOfParticipants < 25)
        return userInformation.refreshDelay * 3;
      else return userInformation.refreshDelay * 6;
    }
  }

  if (raceEdition === null || tempoSettings === null) {
    return <Container>
      <Row className="m-4">
        <Col className=" text-center">
          <p>Loading ...</p>
        </Col>
      </Row>
    </Container>
  } else {
    let currentStage = raceEdition.race.stages[0];

    // didn't manage to calculate this at the place where it's used, therefore it's here
    let sprintPositionsInCurrentGroup = raceEdition.groups[0].racers.slice()
      .filter(racer => racer.positionX > 0 && racer.gapCurrentStage === sprintGroup)
      .map(racer => racer.positionX);
    let sprintPositionXMin = 0;
    let sprintPositionXMax = 0;
    if (sprintPositionsInCurrentGroup.length > 0) {
      sprintPositionXMin = Math.min(...sprintPositionsInCurrentGroup);
      sprintPositionXMax = Math.max(...sprintPositionsInCurrentGroup);
    }

    return <div className="m-0 p-0" style={{ backgroundColor: getBackgroundColor('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName) }}>
      <CalendarModal key={'calendar' + showCalendar}
        raceId={showCalendarRaceId}
        show={showCalendar}
        handleClose={handleCloseCalendar} />
      {raceEdition && (
        raceEdition.sprintStatus !== 'NotStarted' || 
        raceEdition.currentSector === 1 && raceEdition.currentStage > 1 || 
        raceEdition.halfStageWaitingTime > 3) ?
        <ReplayModal key={'replay' + showReplay}
          raceEdition={raceEdition}
          show={showReplay}
          handleClose={handleCloseReplay} />
        : null}
      {raceEdition !== null ?
        <RaceFinancesModal key={'finances' + showFinances}
          raceEdition={raceEdition}
          show={showFinances}
          handleClose={handleCloseFinances} />
        : null}
      {profile !== null ?
        <WeatherForecastModal key={'weatherForecast' + showWeatherForecast}
          weatherForecast={weatherForecast.map(weatherForecast => ({
            ...weatherForecast,
            forecastKm: profile.sectors.findIndex(km => km.forecastId === weatherForecast.id && km.forecastType !== 'Interpolated') + 1
          }))}
          show={showWeatherForecast}
          handleClose={handleCloseWeatherForecast} />
        : null}
      <div className="row d-flex">
        <div className="col py-2 border border-secondary ml-1 mt-1 mr-1 py-1 px-3" style={{ maxWidth: 746, maxHeight: 240, minWidth: 300, backgroundColor: 'rgba(251, 253, 255, 1)' }}>
          <b>Race:</b> {raceEdition.race.raceName}<br />
          <b>Start Time:</b> {raceEdition.startingTime}:00 CET {'halfStageWaitingTime' in raceEdition ? '(restart in ' + raceEdition.halfStageWaitingTime + 'min)' : ''}<br />
          {/* <b>Group:</b> {raceEdition.group}<br /> */}
          <b>Day:</b> {raceEdition.currentStage} / {raceEdition.race.numberOfStages}<br />
          <b>Km:</b> {raceEdition.currentSector} / {currentStage.length} ({currentStage.length - raceEdition.currentSector + 1}km to go)<br />
          <Weather altitude={raceEdition.altitude} windDirection={raceEdition.windDirection}
            windForce={raceEdition.windForce} temperature={raceEdition.temperature}
            cloudCover={raceEdition.cloudCover} precipitation={raceEdition.precipitation}
          />
          <Button variant={'outline-secondary'} size="sm" onClick={() => handleShowWeatherForecast()}>{getLocalizedText('race', 'ButtonWeatherForecast')}</Button>
          <Button className={'mx-1'} variant={'outline-secondary'} size="sm" onClick={() => handleShowFinances()}>{getLocalizedText('race', 'ButtonFinanceDetails')}</Button>
        </div>
        <div className="col-12 border border-secondary ml-0 mt-1 mr-1 py-1 pl-1 pr-0" style={{ maxWidth: 746, maxHeight: 240, backgroundColor: 'rgba(251, 253, 255, 1)' }}>
          <div className="vl" style={{ height: "225px", maxHeight: "100%", borderLeft: "2px solid blue", position: "absolute", left: 0.45 + ((30 / 7.46) + ((raceEdition.currentSector - 1) / currentStage.length) * (((746 - 45) / 7.46) - 0.45)) + "%" }}></div>
          {currentStage.raceType !== 'RestDay' ?
            <img style={{ maxHeight: "100%", maxWidth: "100%", cursor: 'pointer' }}
              onClick={() => handleShowCalendar(raceEdition.race.id)}
              alt="profile needs to be shown here"
              src={config.DIR_PROFILES + currentStage.id + ".png?" + currentISODate}></img>
          : null }
        </div>
      </div>

      <Row className="mt-3 py-0 px-0">
        {profile !== null ? 
            <C4FDetailedProfile key={raceEdition.currentSector} profile={profile}
              rulesetName={raceEdition.race.rulesetName}
              currentSector={raceEdition.currentSector}
              minuteTactStart={currentStage.minuteTactStart}
              lastSector={currentStage.length}
              tablePos={480} />
        : null }

        <Col className="col" style={{ maxWidth: 1000, overflow: "auto" }}>
          <Row>
            <ButtonGroup className="btn-group btn-block ml-2 mr-2">
              <Button className="py-0" variant={tab === 'race' ? 'primary' : 'outline-primary'} onClick={() => setTab('race')}>{getLocalizedText('race', 'NavBarRace')}</Button>
              {(() => {
                if (currentStage.raceType !== 'Regular' && currentStage.raceType !== 'RestDay')
                  return <>
                    <Button variant={(tab === 'tactics') ? 'primary py-0' : 'outline-primary py-0'} onClick={() => setTab('tactics')}>{getLocalizedText('race', 'NavBarTactics')}</Button>
                    <Button variant="outline-primary py-0" disabled>{getLocalizedText('race', 'NavBarMoreTactics')}</Button>
                  </>
                else if (raceEdition.sprintStatus === 'NotStarted' || raceEdition.sprintStatus === 'Completed')
                  return <>
                    <Button variant={(tab === 'tactics') ? 'primary py-0' : 'outline-primary py-0'} onClick={() => setTab('tactics')}>{getLocalizedText('race', 'NavBarTactics')}</Button>
                    <Button variant={(tab === 'moretactics') ? 'primary py-0' : 'outline-primary py-0'} onClick={() => setTab('moretactics')}>{getLocalizedText('race', 'NavBarMoreTactics')}</Button>
                  </>
                else
                  return <>
                    <Button variant="outline-primary py-0" disabled>{getLocalizedText('race', 'NavBarTactics')}</Button>
                    <Button variant="outline-primary py-0" disabled>{getLocalizedText('race', 'NavBarMoreTactics')}</Button>
                  </>
              })()}
              <Button variant={(tab === 'gc') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => handleGCSorting('gc', 'gc')}>
                {getLocalizedText('race', 'NavBarGC')}
                <img alt="GCLeader" src={getJersey('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName, 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} />
              </Button>
              <Button variant={(tab === 'points') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => handleGCSorting('points', 'points')}>
                {getLocalizedText('race', 'NavBarPoints')}
                <img alt="Sprint" src={getJersey('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName, 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} />
              </Button>
              <Button variant={(tab === 'mountain') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => handleGCSorting('mountain', 'mountain')}>
                {getLocalizedText('race', 'NavBarMountain')}
                <img alt="Mountain" src={getJersey('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName, 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} />
              </Button>
              <Button variant={(tab === 'young') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => handleGCSorting('gc', 'young')}>
                {getLocalizedText('race', 'NavBarYouth')}
                <img alt="Youth" src={getJersey('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName, 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} />
              </Button>
              <Button variant={(tab === 'team') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => setTab('team')}>
                {getLocalizedText('race', 'NavBarTeam')}
                <img alt="Team" src={getJersey('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName, 'Team')} style={{ maxHeight: "18px", marginBottom: 1 }} />
              </Button>
              {raceEdition.sprintStatus === 'NotStarted' || currentStage.raceType !== 'Regular' ? (
                <Button className="py-0" variant={tab === 'groups' ? 'primary' : 'outline-primary'}
                  onClick={() => setTab('groups')}>{getLocalizedText('race', 'NavBarGroups')}</Button>
              ) : (
                <Button className="py-0" variant={(tab === 'sprint') ? 'primary' : 'outline-primary'} onClick={() => setTab('sprint')}>
                  {getLocalizedText('race', 'NavBarSprint')}
                </Button>
              )}
              {raceEdition.sprintStatus === 'Completed' ? (
                <Button className="py-0" variant={(tab === 'voting') ? 'primary' : 'outline-primary'} onClick={() => setTab('voting')}>
                  {getLocalizedText('race', 'NavBarVoting')}
                </Button>
              ) : null}
              {raceEdition.sprintStatus === 'Completed' || raceEdition.currentSector <= 1 ? (
                <Button className="py-0" variant={(tab === 'interviews') ? 'primary' : 'outline-primary'} onClick={() => handleInterviews()}>
                  {getLocalizedText('race', 'NavBarInterviews')}
                </Button>
              ) : null}
            </ButtonGroup>
          </Row>

          {(tab !== 'sprint') ?
            (
              <Row className="mt-2 border border-secondary p-0" style={{ height: "550px", overflow: "auto", fontSize: "0.875em", backgroundColor: 'rgba(251, 253, 255, 1)' }}>
                {tab === 'groups' && groupsWithPositions ?
                  <>
                    <Container className="d-flex justify-content-left m-0 p-1" style={{ overflowX: 'auto', marginLeft: 'auto', marginRight: 'auto', maxHeight: 80, backgroundColor: "rgba(245, 250, 255, 1)" }}>

                      <ButtonGroup>
                        <Button className="py-0" size="sm" onClick={() => setGroupDisplayScale(getPreviousElementOfArray(groupDisplaySizes, groupDisplayScale))}
                          variant={'outline-secondary'}>{'\u2796'}</Button>
                        <Button className="py-0" size="sm" onClick={() => setGroupDisplayScale(getNextElementOfArray(groupDisplaySizes, groupDisplayScale))}
                          variant={'outline-secondary'}>{'\u2795'}</Button>

                        {groupsWithPositions
                          .map((group, index) =>
                            group.racers.some(racer => isOwnRacer(racer)) ?
                              <Button className="py-0" size="sm" onClick={() => setSelectedGroupIndex(index)}
                                variant={selectedGroupIndex === index ? 'primary' : 'outline-primary'}>
                                {formatTimeSeconds(group.gap)}
                              </Button>
                              :
                              <Button className="py-0" size="sm" onClick={() => setSelectedGroupIndex(index)}
                                variant={selectedGroupIndex === index ? 'secondary' : 'outline-secondary'}>
                                {formatTimeSeconds(group.gap)}
                              </Button>
                          )}
                      </ButtonGroup>
                    </Container>
                    <Road key={'roadGroups'} x={0} y={0}
                      width={8} length={1000 / groupDisplayScale}
                      scale={groupDisplayScale} 
                      racers={groupsWithPositions[selectedGroupIndex].racers.map(racer => {
                        let team = raceEdition.teams.find(t => t.id === racer.racerTeamId).team;
                        return {
                          ...racer,
                          jerseyFile: getJerseyForRacer(countries, racer, team, raceEdition.race),
                          ownerAcronym: team.acronym
                        }})}
                      info={showRiderInfo}
                      select={handleSelectRacer}
                      unselect={handleUnselectRacer}
                      selectTarget={handleSelectTarget} />
                  </>
                  : null}
                {/* Ongoing normal race (no ITT, TTT) */}
                {tab === 'race' && getRaceTabType() === 'OngoingRegular' ?
                  <Table size="sm" className={'mt-0'}>
                    <thead>
                      <tr className="table-secondary">
                        <th onClick={() => handleRacerTeamSorting('number')} className="th-race sortable" style={{ paddingRight: "5px" }}>Nr</th>
                        <th className="th-race sortable" style={{ paddingRight: "5px" }}>{'\uD83D\uDEE0'}</th>
                        <th onClick={() => handleRacerTeamSorting('lastNames')} className="th-race sortable" style={{ textAlign: "left" }}>Rider</th>
                        <th onClick={() => handleRacerTeamSorting('climbing')} className="th-race sortable" scope="col"><img src={SkillClimbing} title="Mountain" alt="Climbing" /></th>
                        <th onClick={() => handleRacerTeamSorting('flat')} className="th-race sortable" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                        <th onClick={() => handleRacerTeamSorting('downhill')} className="th-race sortable" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                        <th onClick={() => handleRacerTeamSorting('timeTrial')} className="th-race sortable" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                        <th onClick={() => handleRacerTeamSorting('sprint')} className="th-race sortable" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                        <th onClick={() => handleRacerTeamSorting('pave')} className="th-race sortable" scope="col"><img src={SkillCobbles} title="Cobbles" alt="Cobbles" /></th>
                        <th onClick={() => handleRacerTeamSorting('reg')} className="th-race sortable" scope="col"><img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /></th>
                        <th onClick={() => handleRacerTeamSorting('time')} className="th-race sortable" scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Time</th>
                        <th onClick={() => handleRacerTeamSorting('gc')} className={(raceEdition.race.numberOfStages > 1) ? 'th-race sortable' : 'th-race-hidden'} scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Virtual</th>
                        <th className="th-race" scope="col">H / F</th>
                        {/* <th className="th-race" scope="col">Help</th> */}
                        <th className="th-race" scope="col">Tempo</th>
                        <th className="th-race" scope="col">Intensity</th>
                        <th className="th-race" scope="col">Fight</th>
                        <th className="th-race" scope="col">Att.</th>
                        {/* <th className="th-race" scope="col">Follow</th> */}
                        <th className="th-race" scope="col">Energy</th>
                        <th onClick={() => handleRacerTeamSorting('team')} className="th-race sortable" scope="col">Team</th>
                      </tr>
                    </thead>
                    <tbody>
                      {raceEdition.groups[0].racers.slice()
                        .map((racer) => ({ ...racer, ownRider: isOwnRacer(racer) }))
                        .sort(function (a, b) {
                          switch (racerTeamSortBy + ';' + racerTeamSortOrder) {
                            case 'time;asc': return raceEdition.race.rulesetName === 'NationalChampionship' ?
                              a.gapCurrentStage - b.gapCurrentStage
                              || b.tempoSuccess.localeCompare(a.tempoSuccess)
                              || b.ownRider - a.ownRider
                              || a.racerTeamName.localeCompare(b.racerTeamName)
                              :
                              a.gapCurrentStage - b.gapCurrentStage
                              || b.tempoSuccess.localeCompare(a.tempoSuccess)
                              || b.ownRider - a.ownRider
                              || a.number - b.number;
                            case 'time;desc': return raceEdition.race.rulesetName === 'NationalChampionship' ?
                              a.gapCurrentStage - b.gapCurrentStage
                              || b.tempoSuccess.localeCompare(a.tempoSuccess)
                              || b.ownRider - a.ownRider
                              || a.racerTeamName.localeCompare(b.racerTeamName)
                              :
                              a.gapCurrentStage - b.gapCurrentStage
                              || b.tempoSuccess.localeCompare(a.tempoSuccess)
                              || b.ownRider - a.ownRider
                              || a.number - b.number;
                            case 'number;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.number - b.number;
                            case 'number;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.number - a.number;
                            case 'lastNames;desc':
                              return a.gapCurrentStage - b.gapCurrentStage
                                || a.rider.lastNames.localeCompare(b.rider.lastNames)
                                || a.rider.firstNames.localeCompare(b.rider.firstNames);
                            case 'lastNames;asc':
                              return a.gapCurrentStage - b.gapCurrentStage
                                || b.rider.lastNames.localeCompare(a.rider.lastNames)
                                || b.rider.firstNames.localeCompare(a.rider.firstNames);
                            case 'climbing;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Climbing - b.rider.skills.Climbing;
                            case 'climbing;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Climbing - a.rider.skills.Climbing;
                            case 'flat;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Flat - b.rider.skills.Flat;
                            case 'flat;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Flat - a.rider.skills.Flat;
                            case 'downhill;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Downhill - b.rider.skills.Downhill;
                            case 'downhill;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Downhill - a.rider.skills.Downhill;
                            case 'timeTrial;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.TimeTrial - b.rider.skills.TimeTrial;
                            case 'timeTrial;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.TimeTrial - a.rider.skills.TimeTrial;
                            case 'sprint;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Sprint - b.rider.skills.Sprint;
                            case 'sprint;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Sprint - a.rider.skills.Sprint;
                            case 'pave;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || (a.rider.skills.Cobbles * 0.3 + a.rider.skills.Flat * 0.7) - (b.rider.skills.Cobbles * 0.3 + b.rider.skills.Flat * 0.7);
                            case 'pave;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || (b.rider.skills.Cobbles * 0.3 + b.rider.skills.Flat * 0.7) - (a.rider.skills.Cobbles * 0.3 + a.rider.skills.Flat * 0.7);
                            case 'reg;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Regeneration - b.rider.skills.Regeneration;
                            case 'reg;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Regeneration - a.rider.skills.Regeneration;
                            case 'gc;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.gapOverallVirtual - b.gapOverallVirtual
                              || a.number - b.number;
                            case 'gc;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.gapOverallVirtual - b.gapOverallVirtual
                              || a.number - b.number;
                            case 'team;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.racerTeamName.localeCompare(b.racerTeamName);
                            case 'team;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.racerTeamName.localeCompare(a.racerTeamName);
                            default: return a.gapCurrentStage - b.gapCurrentStage
                              || b.tempoSuccess.localeCompare(a.tempoSuccess)
                              || b.ownRider - a.ownRider
                              || a.number - b.number;
                          }
                        })
                        .map((racer) =>
                          <tr className={(racer.group % 2 === 0) ? '' : 'tr-race-alternatingColour'}>
                            <td className="td-race">{racer.number}</td>
                            {isOwnRacer(racer) ?
                              (editRacerTactic !== null && editRacerTactic.id === racer.id ?
                                <td className="td-race td-race-toolSelected" onClick={() => setEditRacerTactic(null)}>
                                  {'\uD83D\uDEE0'}
                                </td>
                                :
                                <td className="td-race td-race-tool" onClick={() => setEditRacerTactic(racer)}>
                                  {'\uD83D\uDEE0'}
                                </td>
                              )
                              :
                              <td className="td-race" ></td>
                            }
                            {editRacerTactic === null ?
                              <td className={'td-race-rider ' + (isOwnRacer(racer) ? 'td-race-ownRider' : '')} >
                                {getRacerNameAndJersey(racer)}
                              </td>
                              :
                              (editRacerTactic.id === racer.id ?
                                <td className={'td-race-rider td-race-ownRider td-race-editClear '}
                                  onClick={() => clearHelpAndFollow(editRacerTactic)}>
                                  {getRacerNameAndJersey(racer)}
                                </td>
                                :
                                (isOwnRacer(racer) ?
                                  <td className={
                                    'td-race-rider td-race-ownRider td-race-editHelp ' +
                                    (racer.id === editRacerTactic.helpsRacer ? 'td-race-selectedRiderHelp ' : '')}
                                    onClick={() => helpRacer(editRacerTactic, racer.id)}>
                                    {getRacerNameAndJersey(racer)}
                                  </td>
                                  :
                                  <td className={
                                    'td-race-rider td-race-editFollow ' +
                                    (racer.id === editRacerTactic.followsRacer ? 'td-race-selectedRiderFollow ' : '')}
                                    onClick={() => followRacer(editRacerTactic, racer.id)}>
                                    {getRacerNameAndJersey(racer)}
                                  </td>
                                )
                              )
                            }
                            <td className="td-race">{racer.rider.skills.Climbing}</td>
                            <td className="td-race">{racer.rider.skills.Flat}</td>
                            <td className="td-race">{racer.rider.skills.Downhill}</td>
                            <td className="td-race">{racer.rider.skills.TimeTrial}</td>
                            <td className="td-race">{racer.rider.skills.Sprint}</td>
                            <td className="td-race">{Math.round((racer.rider.skills.Cobbles * 0.3 + racer.rider.skills.Flat * 0.7) * 10) / 10}</td>
                            <td className="td-race">{racer.rider.skills.Regeneration}</td>
                            <td className="td-race" style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapCurrentStage)}</td>
                            <td className={(raceEdition.race.numberOfStages > 1) ? 'td-race' : 'td-race-hidden'} style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapOverallVirtual)}</td>
                            <td className="td-race">
                              {isOwnRacer(racer) ?
                                <ButtonGroup>
                                  <Button className="py-0 px-1" variant="outline-danger" size="sm" onClick={() => helpRacer(racer, 0)}>
                                    {(racer.helpsRacer === 0) ? '-' : getRiderNumberOnly(racer.helpsRacer)}
                                  </Button>
                                  <Button className="py-0 px-1" variant="outline-danger" size="sm" onClick={() => followRacer(racer, 0)}>
                                    {(racer.followsRacer === 0) ? '-' : getRiderNumberOnly(racer.followsRacer)}
                                  </Button>
                                </ButtonGroup>
                                : null}
                            </td>
                            <td className="td-race">
                              {(() => {
                                let buttonColour = 'secondary';
                                if (racer.tempoIntensity === 'Green') buttonColour = 'success';
                                if (racer.tempoIntensity === 'Blue') buttonColour = 'primary';
                                if (racer.tempoIntensity === 'Red') buttonColour = 'danger';

                                let buttonType = '';
                                if (racer.tempoSuccess !== 'Success') buttonType = 'outline-';

                                if (isOwnRacer(racer)) {
                                  if (racer.tempoStrategy === 'None')
                                    return <Button variant="outline-secondary py-0" size="sm" onClick={() => setTempo(racer, 'Normal', 'None', 'Indefinite')}>Tempo</Button>
                                  else
                                    return <Button className="py-0" variant={buttonType + buttonColour} size="sm" onClick={() => setTempo(racer, 'None', 'None', 'Indefinite')}>Tempo</Button>
                                }
                                else {
                                  if (racer.tempoStrategy === 'None')
                                    return <div>None</div>;
                                  else
                                    return <Button disabled className="py-0" variant={buttonType + buttonColour} size="sm" >Tempo</Button>
                                }
                              }
                              )()}</td>
                            <td className="td-race">
                              {(() => {
                                if (isOwnRacer(racer)) {
                                  if (racer.tempoIntensity === 'Green') {
                                    return <ButtonGroup size="sm" >
                                      <Button variant="success py-0 px-1" onClick={() => setIntensity(racer, 'Green')}>{getLocalizedText('referenceData', 'TempoIntensityGreen')}</Button>
                                      <Button variant="outline-primary py-0 px-1" onClick={() => setIntensity(racer, 'Blue')}>{getLocalizedText('referenceData', 'TempoIntensityBlue')}</Button>
                                      <Button variant="outline-danger py-0 px-1" onClick={() => setIntensity(racer, 'Red')}>{getLocalizedText('referenceData', 'TempoIntensityRed')}</Button>
                                    </ButtonGroup>
                                  }
                                  if (racer.tempoIntensity === 'Blue') {
                                    return <ButtonGroup size="sm" >
                                      <Button variant="outline-success py-0 px-1" onClick={() => setIntensity(racer, 'Green')}>{getLocalizedText('referenceData', 'TempoIntensityGreen')}</Button>
                                      <Button variant="primary py-0 px-1" onClick={() => setIntensity(racer, 'Blue')}>{getLocalizedText('referenceData', 'TempoIntensityBlue')}</Button>
                                      <Button variant="outline-danger py-0 px-1" onClick={() => setIntensity(racer, 'Red')}>{getLocalizedText('referenceData', 'TempoIntensityRed')}</Button>
                                    </ButtonGroup>
                                  }
                                  if (racer.tempoIntensity === 'Red') {
                                    return <ButtonGroup size="sm" >
                                      <Button variant="outline-success py-0 px-1" onClick={() => setIntensity(racer, 'Green')}>{getLocalizedText('referenceData', 'TempoIntensityGreen')}</Button>
                                      <Button variant="outline-primary py-0 px-1" onClick={() => setIntensity(racer, 'Blue')}>{getLocalizedText('referenceData', 'TempoIntensityBlue')}</Button>
                                      <Button variant="danger py-0 px-1" onClick={() => setIntensity(racer, 'Red')}>{getLocalizedText('referenceData', 'TempoIntensityRed')}</Button>
                                    </ButtonGroup>
                                  }
                                }
                              })()}
                            </td>
                            <td className="td-race">
                              {(() => {
                                if (isOwnRacer(racer)) {
                                  if (racer.endurance === 'Fighting') {
                                    return <Button size="sm" variant="info py-0" onClick={() => setEndurance(racer, 'KeepingUp')}>y</Button>
                                  }
                                  else {
                                    return <Button size="sm" variant="outline-info py-0" onClick={() => setEndurance(racer, 'Fighting')}>n</Button>
                                  }
                                }
                              })()}
                            </td>
                            <td className="td-race">
                              {(() => {
                                if (isOwnRacer(racer)) {
                                  if (racer.attackAt !== raceEdition.currentSector) {
                                    return <Button variant="outline-secondary py-0" size="sm" onClick={() => attackAt(racer, raceEdition.currentSector)}>{racer.attackAt}</Button>
                                  }
                                  else {
                                    if (racer.tempoIntensity === 'Green') {
                                      return <Button variant="success py-0" size="sm" onClick={() => attackAt(racer, 0)}>{racer.attackAt}</Button>
                                    }
                                    if (racer.tempoIntensity === 'Blue') {
                                      return <Button variant="primary py-0" size="sm" onClick={() => attackAt(racer, 0)}>{racer.attackAt}</Button>
                                    }
                                    if (racer.tempoIntensity === 'Red') {
                                      return <Button variant="danger py-0" size="sm" onClick={() => attackAt(racer, 0)}>{racer.attackAt}</Button>
                                    }
                                  }
                                }
                              })()}
                            </td>
                            {(() => {
                              if (isOwnRacer(racer)) {
                                if (racer.energySectorEnd > 8000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 156, 34, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                if (racer.energySectorEnd > 6000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 114, 184, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                if (racer.energySectorEnd > 4000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 149, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                if (racer.energySectorEnd > 2000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 83, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                else {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(203, 6, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                              } else {
                                return <td className="td-race"></td>
                              }
                            })()}
                            <td className="td-race"
                              style={(isOwnRacer(racer)) ? { fontWeight: "bold" } : {}}>
                              <a href="#" onClick={() => showTeamInfo(getTeamByRacerTeamId(racer.racerTeamId))} style={{ color: "black" }}>{(racer.racerTeamName.length > 20) ? (racer.racerTeamName.substr(0, 17) + '...') : racer.racerTeamName}</a>
                            </td>
                          </tr>
                        )
                      }
                    </tbody>
                  </Table>
                  : null}
                {/* Ongoing ITT */}
                {tab === 'race' && getRaceTabType() === 'OngoingIndividualTimeTrial' ?
                  <Table size="sm" className={'mt-0'}>
                    <thead>
                      <tr className="table-secondary">
                        <th onClick={() => handleRacerTeamSorting('number')} className="th-race sortable" style={{ paddingRight: "5px" }}>Nr</th>
                        <th onClick={() => handleRacerTeamSorting('lastNames')} className="th-race sortable" style={{ textAlign: "left" }}>Rider</th>
                        <th onClick={() => handleRacerTeamSorting('climbing')} className="th-race sortable" scope="col"><img src={SkillClimbing} title="Mountain" alt="Climbing" /></th>
                        <th onClick={() => handleRacerTeamSorting('flat')} className="th-race sortable" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                        <th onClick={() => handleRacerTeamSorting('downhill')} className="th-race sortable" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                        <th onClick={() => handleRacerTeamSorting('timeTrial')} className="th-race sortable" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                        <th onClick={() => handleRacerTeamSorting('sprint')} className="th-race sortable" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                        <th onClick={() => handleRacerTeamSorting('pave')} className="th-race sortable" scope="col"><img src={SkillCobbles} title="Cobbles" alt="Cobbles" /></th>
                        <th onClick={() => handleRacerTeamSorting('reg')} className="th-race sortable" scope="col"><img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /></th>
                        <th onClick={() => handleRacerTeamSorting('time')} className="th-race sortable" scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Time</th>
                        <th onClick={() => handleRacerTeamSorting('gc')} className={(raceEdition.race.numberOfStages > 1) ? 'th-race sortable' : 'th-race-hidden'} scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Virtual</th>
                        <th className="th-race" scope="col">Tempo</th>
                        <th className="th-race" scope="col">Risk</th>
                        <th className="th-race" scope="col">Energy</th>
                        <th onClick={() => handleRacerTeamSorting('team')} className="th-race sortable" scope="col">Team</th>
                      </tr>
                    </thead>
                    <tbody>
                      {raceEdition.groups[0].racers.slice()
                        .map((racer) => ({
                          ...racer,
                          ownRider: isOwnRacer(racer),
                          cobbles: Math.round((racer.rider.skills.Cobbles * 0.3 + racer.rider.skills.Flat * 0.7) * 10) / 10
                        }))
                        .sort(function (a, b) {
                          switch (racerTeamSortBy + ';' + racerTeamSortOrder) {
                            case 'time;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.ownRider - a.ownRider
                              || a.number - b.number;
                            case 'time;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.ownRider - a.ownRider
                              || a.number - b.number;
                            case 'number;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.number - b.number;
                            case 'number;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.number - a.number;
                            case 'lastNames;desc':
                              return a.gapCurrentStage - b.gapCurrentStage
                                || a.rider.lastNames.localeCompare(b.rider.lastNames)
                                || a.rider.firstNames.localeCompare(b.rider.firstNames);
                            case 'lastNames;asc':
                              return a.gapCurrentStage - b.gapCurrentStage
                                || b.rider.lastNames.localeCompare(a.rider.lastNames)
                                || b.rider.firstNames.localeCompare(a.rider.firstNames);
                            case 'climbing;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Climbing - b.rider.skills.Climbing;
                            case 'climbing;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Climbing - a.rider.skills.Climbing;
                            case 'flat;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Flat - b.rider.skills.Flat;
                            case 'flat;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Flat - a.rider.skills.Flat;
                            case 'downhill;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Downhill - b.rider.skills.Downhill;
                            case 'downhill;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Downhill - a.rider.skills.Downhill;
                            case 'timeTrial;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.TimeTrial - b.rider.skills.TimeTrial;
                            case 'timeTrial;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.TimeTrial - a.rider.skills.TimeTrial;
                            case 'sprint;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Sprint - b.rider.skills.Sprint;
                            case 'sprint;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Sprint - a.rider.skills.Sprint;
                            case 'pave;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || (a.rider.skills.Cobbles * 0.3 + a.rider.skills.Flat * 0.7) - (b.rider.skills.Cobbles * 0.3 + b.rider.skills.Flat * 0.7);
                            case 'pave;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || (b.rider.skills.Cobbles * 0.3 + b.rider.skills.Flat * 0.7) - (a.rider.skills.Cobbles * 0.3 + a.rider.skills.Flat * 0.7);
                            case 'reg;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.skills.Regeneration - b.rider.skills.Regeneration;
                            case 'reg;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.skills.Regeneration - a.rider.skills.Regeneration;
                            case 'gc;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.gapOverallVirtual - b.gapOverallVirtual
                              || a.number - b.number;
                            case 'gc;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.gapOverallVirtual - a.gapOverallVirtual
                              || a.number - b.number;
                            case 'team;desc': return a.gapCurrentStage - b.gapCurrentStage
                              || a.racerTeamName.localeCompare(b.racerTeamName);
                            case 'team;asc': return a.gapCurrentStage - b.gapCurrentStage
                              || b.racerTeamName.localeCompare(a.racerTeamName);
                            default: return a.gapCurrentStage - b.gapCurrentStage
                              || b.ownRider - a.ownRider
                              || a.number - b.number;
                          }
                        })
                        .map((racer) =>
                          <tr className={(racer.group % 2 === 0) ? '' : 'table-primary'}>
                            <td className="td-race">{racer.number}</td>
                            <td className="td-race" style={(isOwnRacer(racer)) ? { fontWeight: "bold", textAlign: "left" } : { textAlign: "left" }}>
                              {getRacerNameAndJersey(racer)}
                            </td>
                            <td className="td-race">{racer.rider.skills.Climbing}</td>
                            <td className="td-race">{racer.rider.skills.Flat}</td>
                            <td className="td-race">{racer.rider.skills.Downhill}</td>
                            <td className="td-race">{racer.rider.skills.TimeTrial}</td>
                            <td className="td-race">{racer.rider.skills.Sprint}</td>
                            <td className="td-race">{Math.round((racer.rider.skills.Cobbles * 0.3 + racer.rider.skills.Flat * 0.7) * 10) / 10}</td>
                            <td className="td-race">{racer.rider.skills.Regeneration}</td>
                            <td className="td-race" style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapCurrentStage)}</td>
                            <td className={(raceEdition.race.numberOfStages > 1) ? 'td-race' : 'td-race-hidden'} style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapOverallVirtual)}</td>
                            <td className="td-race">
                              {(() => {
                                if (isOwnRacer(racer))
                                  return <ButtonGroup>
                                    <Button variant={(racer.ittTempoIntensity === 'Tempo75') ? 'success py-0' : 'outline-success py-0'}
                                      size="sm" onClick={() => setTempoITT(racer, 'Tempo75', racer.ittRisk)}>75</Button>
                                    <Button variant={(racer.ittTempoIntensity === 'Tempo80') ? 'primary py-0' : 'outline-primary py-0'}
                                      size="sm" onClick={() => setTempoITT(racer, 'Tempo80', racer.ittRisk)}>80</Button>
                                    <Button variant={(racer.ittTempoIntensity === 'Tempo85') ? 'primary py-0' : 'outline-primary py-0'}
                                      size="sm" onClick={() => setTempoITT(racer, 'Tempo85', racer.ittRisk)}>85</Button>
                                    <Button variant={(racer.ittTempoIntensity === 'Tempo90') ? 'warning py-0' : 'outline-warning py-0'}
                                      size="sm" onClick={() => setTempoITT(racer, 'Tempo90', racer.ittRisk)}>90</Button>
                                    <Button variant={(racer.ittTempoIntensity === 'Tempo95') ? 'warning py-0' : 'outline-warning py-0'}
                                      size="sm" onClick={() => setTempoITT(racer, 'Tempo95', racer.ittRisk)}>95</Button>
                                    <Button variant={(racer.ittTempoIntensity === 'Tempo100') ? 'danger py-0' : 'outline-danger py-0'}
                                      size="sm" onClick={() => setTempoITT(racer, 'Tempo100', racer.ittRisk)}>100</Button>
                                  </ButtonGroup>
                              })()}
                            </td>
                            <td className="td-race">
                              {(() => {
                                if (isOwnRacer(racer))
                                  return <ButtonGroup>
                                    <Button variant={(racer.ittRisk === 'Low') ? 'success py-0' : 'outline-success py-0'}
                                      size="sm" onClick={() => setTempoITT(racer, racer.ittTempoIntensity, 'Low')}>l</Button>
                                    <Button variant={(racer.ittRisk === 'Medium') ? 'primary py-0' : 'outline-primary py-0'}
                                      size="sm" onClick={() => setTempoITT(racer, racer.ittTempoIntensity, 'Medium')}>m</Button>
                                    <Button variant={(racer.ittRisk === 'High') ? 'danger py-0' : 'outline-danger py-0'}
                                      size="sm" onClick={() => setTempoITT(racer, racer.ittTempoIntensity, 'High')}>h</Button>
                                  </ButtonGroup>
                              })()}
                            </td>
                            {(() => {
                              if (isOwnRacer(racer)) {
                                if (racer.energySectorEnd > 8000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 156, 34, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                if (racer.energySectorEnd > 6000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 114, 184, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                if (racer.energySectorEnd > 4000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 149, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                if (racer.energySectorEnd > 2000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 83, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                else {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(203, 6, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                              } else {
                                return <td className="td-race"></td>
                              }
                            })()}
                            <td className="td-race" style={(isOwnRacer(racer)) ? { fontWeight: "bold" } : {}}>
                              <a href="#" onClick={() => showTeamInfo(getTeamByRacerTeamId(racer.racerTeamId))}
                                style={{ color: "black" }}>{(racer.racerTeamName.length > 20) ? (racer.racerTeamName.substr(0, 17) + '...') : racer.racerTeamName}
                              </a>
                            </td>
                          </tr>
                        )
                      }
                    </tbody>
                  </Table>
                  : null}
                {/* Ongoing TTT */}
                {tab === 'race' && getRaceTabType() === 'OngoingTeamTimeTrial' ?
                  <Table size="sm" className={'mt-0'}>
                  <thead>
                    <tr className="table-secondary">
                      <th onClick={() => handleRacerTeamSorting('number')} className="th-race sortable" style={{ paddingRight: "5px" }}>Nr</th>
                      <th onClick={() => handleRacerTeamSorting('lastNames')} className="th-race sortable" style={{ textAlign: "left" }}>Rider</th>
                      <th onClick={() => handleRacerTeamSorting('climbing')} className="th-race sortable" scope="col"><img src={SkillClimbing} title="Mountain" alt="Climbing" /></th>
                      <th onClick={() => handleRacerTeamSorting('flat')} className="th-race sortable" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                      <th onClick={() => handleRacerTeamSorting('downhill')} className="th-race sortable" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                      <th onClick={() => handleRacerTeamSorting('timeTrial')} className="th-race sortable" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                      <th onClick={() => handleRacerTeamSorting('sprint')} className="th-race sortable" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                      <th onClick={() => handleRacerTeamSorting('pave')} className="th-race sortable" scope="col"><img src={SkillCobbles} title="Cobbles" alt="Cobbles" /></th>
                      <th onClick={() => handleRacerTeamSorting('reg')} className="th-race sortable" scope="col"><img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /></th>
                      <th onClick={() => handleRacerTeamSorting('time')} className="th-race sortable" scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Time</th>
                      <th onClick={() => handleRacerTeamSorting('gc')} className={(raceEdition.race.numberOfStages > 1) ? 'th-race sortable' : 'th-race-hidden'} scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Virtual</th>
                      <th className="th-race" scope="col">Tempo</th>
                      <th className="th-race" scope="col">Effort</th>
                      <th className="th-race" scope="col">Wait</th>
                      <th className="th-race" scope="col">Energy</th>
                      <th onClick={() => handleRacerTeamSorting('team')} className="th-race sortable" scope="col">Team</th>
                    </tr>
                  </thead>
                  <tbody>
                    {raceEdition.groups[0].racers.slice()
                      .map((racer) => ({ ...racer, ownRider: isOwnRacer(racer) }))
                      .sort(function (a, b) {
                        switch (racerTeamSortBy + ';' + racerTeamSortOrder) {
                          case 'time;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.ownRider - a.ownRider
                            || a.number - b.number;
                          case 'time;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.ownRider - a.ownRider
                            || a.number - b.number;
                          case 'number;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || a.number - b.number;
                          case 'number;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.number - a.number;
                          case 'lastNames;desc':
                            return a.gapCurrentStage - b.gapCurrentStage
                              || a.rider.lastNames.localeCompare(b.rider.lastNames)
                              || a.rider.firstNames.localeCompare(b.rider.firstNames);
                          case 'lastNames;asc':
                            return a.gapCurrentStage - b.gapCurrentStage
                              || b.rider.lastNames.localeCompare(a.rider.lastNames)
                              || b.rider.firstNames.localeCompare(a.rider.firstNames);
                          case 'climbing;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || a.rider.skills.Climbing - b.rider.skills.Climbing;
                          case 'climbing;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.rider.skills.Climbing - a.rider.skills.Climbing;
                          case 'flat;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || a.rider.skills.Flat - b.rider.skills.Flat;
                          case 'flat;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.rider.skills.Flat - a.rider.skills.Flat;
                          case 'downhill;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || a.rider.skills.Downhill - b.rider.skills.Downhill;
                          case 'downhill;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.rider.skills.Downhill - a.rider.skills.Downhill;
                          case 'timeTrial;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || a.rider.skills.TimeTrial - b.rider.skills.TimeTrial;
                          case 'timeTrial;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.rider.skills.TimeTrial - a.rider.skills.TimeTrial;
                          case 'sprint;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || a.rider.skills.Sprint - b.rider.skills.Sprint;
                          case 'sprint;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.rider.skills.Sprint - a.rider.skills.Sprint;
                          case 'pave;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || (a.rider.skills.Cobbles * 0.3 + a.rider.skills.Flat * 0.7) - (b.rider.skills.Cobbles * 0.3 + b.rider.skills.Flat * 0.7);
                          case 'pave;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || (b.rider.skills.Cobbles * 0.3 + b.rider.skills.Flat * 0.7) - (a.rider.skills.Cobbles * 0.3 + a.rider.skills.Flat * 0.7);
                          case 'reg;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || a.rider.skills.Regeneration - b.rider.skills.Regeneration;
                          case 'reg;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.rider.skills.Regeneration - a.rider.skills.Regeneration;
                          case 'gc;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || a.gapOverallVirtual - b.gapOverallVirtual
                            || a.number - b.number;
                          case 'gc;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.gapOverallVirtual - a.gapOverallVirtual
                            || a.number - b.number;
                          case 'team;desc': return a.gapCurrentStage - b.gapCurrentStage
                            || a.racerTeamName.localeCompare(b.racerTeamName);
                          case 'team;asc': return a.gapCurrentStage - b.gapCurrentStage
                            || b.racerTeamName.localeCompare(a.racerTeamName);
                          default: return a.gapCurrentStage - b.gapCurrentStage
                            || b.ownRider - a.ownRider
                            || a.number - b.number;
                        }
                      })
                      .map((racer) =>
                        <tr className={(racer.group % 2 === 0) ? '' : 'table-primary'}>
                          <td className="td-race">{racer.number}</td>
                          <td className="td-race" style={(isOwnRacer(racer)) ? { fontWeight: "bold", textAlign: "left" } : { textAlign: "left" }}>
                            {getRacerNameAndJersey(racer)}
                          </td>
                          <td className="td-race">{racer.rider.skills.Climbing}</td>
                          <td className="td-race">{racer.rider.skills.Flat}</td>
                          <td className="td-race">{racer.rider.skills.Downhill}</td>
                          <td className="td-race">{racer.rider.skills.TimeTrial}</td>
                          <td className="td-race">{racer.rider.skills.Sprint}</td>
                          <td className="td-race">{Math.round((racer.rider.skills.Cobbles * 0.3 + racer.rider.skills.Flat * 0.7) * 10) / 10}</td>
                          <td className="td-race">{racer.rider.skills.Regeneration}</td>
                          <td className="td-race" style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapCurrentStage)}</td>
                          <td className={(raceEdition.race.numberOfStages > 1) ? 'td-race' : 'td-race-hidden'} style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapOverallVirtual)}</td>
                          <td className="td-race">
                            {(() => {
                              if (isOwnRacer(racer))
                                return <ButtonGroup>
                                  <Button variant={(racer.tttTempoShare === 'None') ? 'secondary py-0' : 'outline-secondary py-0'}
                                    size="sm" onClick={() => setTempoTTT(racer, 'None', racer.tttWaitForRider, racer.tttEffort)}>x</Button>
                                  <Button variant={(racer.tttTempoShare === 'Low') ? 'success py-0' : 'outline-success py-0'}
                                    size="sm" onClick={() => setTempoTTT(racer, 'Low', racer.tttWaitForRider, racer.tttEffort)}>l</Button>
                                  <Button variant={(racer.tttTempoShare === 'Medium') ? 'primary py-0' : 'outline-primary py-0'}
                                    size="sm" onClick={() => setTempoTTT(racer, 'Medium', racer.tttWaitForRider, racer.tttEffort)}>m</Button>
                                  <Button variant={(racer.tttTempoShare === 'High') ? 'danger py-0' : 'outline-danger py-0'}
                                    size="sm" onClick={() => setTempoTTT(racer, 'High', racer.tttWaitForRider, racer.tttEffort)}>h</Button>
                                </ButtonGroup>
                            })()}
                          </td>
                          <td className="td-race">
                            {(() => {
                              if (isOwnRacer(racer))
                                return <ButtonGroup>
                                  <Button variant={(racer.tttEffort === 'Low') ? 'success py-0' : 'outline-success py-0'}
                                    size="sm" onClick={() => setTempoTTT(racer, racer.tttTempoShare, racer.tttWaitForRider, 'Low')}>l</Button>
                                  <Button variant={(racer.tttEffort === 'High') ? 'danger py-0' : 'outline-danger py-0'}
                                    size="sm" onClick={() => setTempoTTT(racer, racer.tttTempoShare, racer.tttWaitForRider, 'High')}>h</Button>
                                </ButtonGroup>
                            })()}
                          </td>
                          <td className="td-race">
                            {(() => {
                              if (isOwnRacer(racer))
                                return <ButtonGroup>
                                  <Button variant={(racer.tttWaitForRider === 'Yes') ? 'success py-0' : 'outline-success py-0'}
                                    size="sm" onClick={() => setTempoTTT(racer, racer.tttTempoShare, 'Yes', racer.tttEffort)}>y</Button>
                                  <Button variant={(racer.tttWaitForRider === 'No') ? 'danger py-0' : 'outline-danger py-0'}
                                    size="sm" onClick={() => setTempoTTT(racer, racer.tttTempoShare, 'No', racer.tttEffort)}>n</Button>
                                </ButtonGroup>
                            })()}
                          </td>
                          {(() => {
                            if (isOwnRacer(racer)) {
                              if (racer.energySectorEnd > 8000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 156, 34, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              if (racer.energySectorEnd > 6000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 114, 184, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              if (racer.energySectorEnd > 4000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 149, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              if (racer.energySectorEnd > 2000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 83, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              else {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(203, 6, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                            } else {
                              return <td className="td-race"></td>
                            }
                          })()}
                          <td className="td-race" style={(isOwnRacer(racer)) ? { fontWeight: "bold" } : {}}>
                            <a href="#" onClick={() => showTeamInfo(getTeamByRacerTeamId(racer.racerTeamId))}
                              style={{ color: "black" }}>{(racer.racerTeamName.length > 20) ? (racer.racerTeamName.substr(0, 17) + '...') : racer.racerTeamName}
                            </a>
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                  </Table>
                  : null}
                {/* Rest Day / Completed Race / display between half stages */}
                {tab === 'race' && getRaceTabType() === 'Completed' ?
                  <Table size="sm" className={'mt-0'}>
                  <thead>
                    <tr className="table-secondary">
                      <th className="th-race" style={{ padding: "1px", paddingRight: "5 px" }}>Nr</th>
                      <th className="th-race" style={{ padding: "1px", textAlign: "left" }}>Rider</th>
                      <th className="th-race" scope="col"><img src={SkillClimbing} title="Climbing" alt="Climbing" /></th>
                      <th className="th-race" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                      <th className="th-race" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                      <th className="th-race" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                      <th className="th-race" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                      <th className="th-race" scope="col"><img src={SkillCobbles} title="Cobbles" alt="Cobbles" /></th>
                      <th className="th-race" scope="col"><img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /></th>
                      <th className="th-race" scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Time</th>
                      <th className={(raceEdition.race.numberOfStages > 1) ? 'th-race' : 'th-race-hidden'} scope="col" style={{ textAlign: "right", paddingRight: 10 }}>GC</th>
                      <th className="th-race" scope="col">Energy</th>
                      <th className="th-race" scope="col">Team</th>
                    </tr>
                  </thead>
                  <tbody>

                    {
                      raceEdition.groups[0].racers.slice()
                        .map((racer) => ({ ...racer, ownRider: isOwnRacer(racer) }))
                        .sort(function (a, b) {
                          return a.gapCurrentStage - b.gapCurrentStage
                            || b.positionX - a.positionX
                            || b.sprintRelativePosition - a.sprintRelativePosition
                        })
                        .map((racer, index) =>
                          <tr className={(racer.group % 2 === 0) ? '' : 'table-primary'}>
                            <td className="td-race">{index + 1}</td>
                            <td className="td-race" style={(isOwnRacer(racer)) ? { fontWeight: "bold", textAlign: "left" } : { textAlign: "left" }}>
                              {getRacerNameAndJersey(racer)}
                            </td>
                            <td className="td-race">{racer.rider.skills.Climbing}</td>
                            <td className="td-race">{racer.rider.skills.Flat}</td>
                            <td className="td-race">{racer.rider.skills.Downhill}</td>
                            <td className="td-race">{racer.rider.skills.TimeTrial}</td>
                            <td className="td-race">{racer.rider.skills.Sprint}</td>
                            <td className="td-race">{Math.round((racer.rider.skills.Cobbles * 0.3 + racer.rider.skills.Flat * 0.7) * 10) / 10}</td>
                            <td className="td-race">{racer.rider.skills.Regeneration}</td>
                            <td className="td-race" style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapCurrentStage)}</td>
                            <td className={(raceEdition.race.numberOfStages > 1) ? 'td-race' : 'td-race-hidden'} style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapOverall)}</td>
                            {(() => {
                              if (isOwnRacer(racer)) {
                                if (racer.energySectorEnd > 8000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 156, 34, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                if (racer.energySectorEnd > 6000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 114, 184, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                if (racer.energySectorEnd > 4000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 149, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                if (racer.energySectorEnd > 2000) {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 83, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                                else {
                                  return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(203, 6, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                }
                              } else {
                                return <td className="td-race"></td>
                              }
                            })()}
                            <td className="td-race" style={(isOwnRacer(racer)) ? { fontWeight: "bold" } : {}}>
                              <a href="#" onClick={() => showTeamInfo(getTeamByRacerTeamId(racer.racerTeamId))}
                                style={{ color: "black" }}>{(racer.racerTeamName.length > 20) ? (racer.racerTeamName.substr(0, 17) + '...') : racer.racerTeamName}
                              </a>
                            </td>
                          </tr>
                        )
                    }
                  </tbody>
                </Table>
                  : null}
                <Table striped size="sm" className={(tab === "tactics") ? 'mt-0' : 'hidden'}>
                  <thead>
                    <tr className="table-secondary">
                      <th className="th-race" scope="col">#</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsRider')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsTempo')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsIntensity')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsAction')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsUntil')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsHelps')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsFollow')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsFight')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsSprint')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsForm')}</th>
                      <th className="th-race" scope="col">{getLocalizedText('race', 'TacticsEnergy')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {raceEdition.groups[0].racers.slice()
                    .filter(racer => isOwnRacer(racer))
                      .sort(function (a, b) { return a.number - b.number })
                      .map((racer) => (
                        <tr>
                          <td>{racer.number}</td>
                          <td >
                            <a href="#" onClick={() => showRiderInfo(racer.rider)} style={{ color: '#000000' }}>
                              {racer.rider.firstNames} {racer.rider.lastNames}
                            </a>
                          </td>
                          <td>
                            <ButtonGroup>
                              {(() => {
                                if (raceEdition.sprintStatus === 'Completed'
                                  || currentStage.raceType === 'IndividualTimeTrial'
                                  || currentStage.raceType === 'TeamTimeTrial')
                                  return <>
                                    <DropdownButton size="sm" variant={'outline-secondary py-0 px-1'} title='None' disabled />
                                    <Button size="sm" variant="outline-danger py-0 px-1" disabled>x</Button>
                                  </>
                                else
                                  return <>
                                    <DropdownButton size="sm" variant={(racer.tempoStrategy === 'None') ? 'outline-secondary py-0 px-1' : 'secondary py-0 px-1'}
                                      title={getLocalizedText('referenceData', 'TempoStrategy' + racer.tempoStrategy)}
                                      onSelect={(newTempoStrategy, e) => setTempo(racer, newTempoStrategy, 'None', 'Indefinite')}>
                                      {['None', 'Normal', 'Alone', 'Shared'].map((tempoStrategy) => {
                                        if (racer.tempoStrategy === tempoStrategy)
                                          return <Dropdown.Item active eventKey={tempoStrategy}>{getLocalizedText('referenceData', 'TempoStrategy' + tempoStrategy)}</Dropdown.Item>
                                        else
                                          return <Dropdown.Item eventKey={tempoStrategy}>{getLocalizedText('referenceData', 'TempoStrategy' + tempoStrategy)}</Dropdown.Item>

                                      })}
                                    </DropdownButton>
                                    <Button size="sm" variant="outline-danger py-0 px-1" onClick={() => setTempo(racer, 'None', 'None', 'Indefinite')}>x</Button>
                                  </>
                              })()}
                            </ButtonGroup>
                          </td>
                          <td>
                            {(() => {
                              if (isOwnRacer(racer)) {
                                if (racer.tempoIntensity === 'Green') {
                                  return <ButtonGroup size="sm" >
                                    <Button variant="success py-0 px-1" onClick={() => setIntensity(racer, 'Green')}>{getLocalizedText('referenceData', 'TempoIntensityGreen')}</Button>
                                    <Button variant="outline-primary py-0 px-1" onClick={() => setIntensity(racer, 'Blue')}>{getLocalizedText('referenceData', 'TempoIntensityBlue')}</Button>
                                    <Button variant="outline-danger py-0 px-1" onClick={() => setIntensity(racer, 'Red')}>{getLocalizedText('referenceData', 'TempoIntensityRed')}</Button>
                                  </ButtonGroup>
                                }
                                if (racer.tempoIntensity === 'Blue') {
                                  return <ButtonGroup size="sm" >
                                    <Button variant="outline-success py-0 px-1" onClick={() => setIntensity(racer, 'Green')}>{getLocalizedText('referenceData', 'TempoIntensityGreen')}</Button>
                                    <Button variant="primary py-0 px-1" onClick={() => setIntensity(racer, 'Blue')}>{getLocalizedText('referenceData', 'TempoIntensityBlue')}</Button>
                                    <Button variant="outline-danger py-0 px-1" onClick={() => setIntensity(racer, 'Red')}>{getLocalizedText('referenceData', 'TempoIntensityRed')}</Button>
                                  </ButtonGroup>
                                }
                                if (racer.tempoIntensity === 'Red') {
                                  return <ButtonGroup size="sm" >
                                    <Button variant="outline-success py-0 px-1" onClick={() => setIntensity(racer, 'Green')}>{getLocalizedText('referenceData', 'TempoIntensityGreen')}</Button>
                                    <Button variant="outline-primary py-0 px-1" onClick={() => setIntensity(racer, 'Blue')}>{getLocalizedText('referenceData', 'TempoIntensityBlue')}</Button>
                                    <Button variant="danger py-0 px-1" onClick={() => setIntensity(racer, 'Red')}>{getLocalizedText('referenceData', 'TempoIntensityRed')}</Button>
                                  </ButtonGroup>
                                }
                              }
                            })()}
                          </td>
                          <td>
                            {(() => {
                              if (raceEdition.sprintStatus === 'Completed'
                                || currentStage.raceType === 'IndividualTimeTrial'
                                || currentStage.raceType === 'TeamTimeTrial')
                                return <DropdownButton variant={'outline-secondary py-0 px-1'} size="sm" title='None' disabled />
                              else
                                return <DropdownButton variant={(racer.tempoAction === 'None') ? 'outline-secondary py-0 px-1' : 'secondary py-0 px-1'}
                                  size="sm"
                                  title={getLocalizedText('referenceData', 'TempoAction' + racer.tempoAction)}
                                  onSelect={(newTempoAction, e) => {
                                    let newTempoUntil = racer.tempoUntil;
                                    if (newTempoAction !== 'StartWhenDropped') newTempoUntil = 'Indefinite';
                                    setTempo(racer, 'None', newTempoAction, newTempoUntil);
                                  }}>
                                  {['None', 'WaitForLeader', 'DropFromGroup', 'StartWhenDropped'].map((tempoAction) => {
                                    if (racer.tempoAction === tempoAction)
                                      return <Dropdown.Item active eventKey={tempoAction}>{getLocalizedText('referenceData', 'TempoAction' + tempoAction)}</Dropdown.Item>
                                    else
                                      return <Dropdown.Item eventKey={tempoAction}>{getLocalizedText('referenceData', 'TempoAction' + tempoAction)}</Dropdown.Item>
                                  })}
                                </DropdownButton>
                            })()}
                          </td>
                          <td>
                            {(() => {
                              if (raceEdition.sprintStatus === 'Completed'
                                || currentStage.raceType === 'IndividualTimeTrial'
                                || currentStage.raceType === 'TeamTimeTrial')
                                return <DropdownButton variant={'outline-secondary py-0 px-1'} size="sm" title={getLocalizedText('referenceData', 'TempoUntilIndefinite')} disabled />
                              else if (racer.tempoAction === 'DropFromGroup' ||
                                racer.tempoAction === 'WaitForLeader' ||
                                (racer.tempoStrategy === 'None' && racer.tempoAction === 'None'))
                                return <DropdownButton variant={'outline-secondary py-0 px-1'} size="sm" title={getLocalizedText('referenceData', 'TempoUntil' + racer.tempoUntil)} disabled />
                              else
                                return <DropdownButton variant={(racer.tempoUntil === 'Indefinite') ? 'outline-secondary py-0 px-1' : 'secondary py-0 px-1'}
                                  size="sm"
                                  title={getLocalizedText('referenceData', 'TempoUntil' + racer.tempoUntil)}
                                  onSelect={(newTempoUntil, e) => {
                                    let newTempoStrategy = racer.tempoStrategy;
                                    if (racer.tempoStrategy === 'Shared' || racer.tempoStrategy === 'Alone')
                                      newTempoStrategy = 'Normal';
                                    setTempo(racer, newTempoStrategy, racer.tempoAction, newTempoUntil)
                                  }}>
                                  {['Indefinite', 'Dropped', 'ReachPeloton', 'ReachFront'].map((tempoUntil) => {
                                    if (racer.tempoUntil === tempoUntil)
                                      return <Dropdown.Item active eventKey={tempoUntil}>{getLocalizedText('referenceData', 'TempoUntil' + tempoUntil)}</Dropdown.Item>
                                    else
                                      return <Dropdown.Item eventKey={tempoUntil}>{getLocalizedText('referenceData', 'TempoUntil' + tempoUntil)}</Dropdown.Item>
                                  })}
                                </DropdownButton>
                            })()}
                          </td>
                          <td>
                            <ButtonGroup>
                              <DropdownButton variant="outline-secondary py-0 px-1"
                                size="sm"
                                title={(racer.helpsRacer === 0) ? getLocalizedText('referenceData', 'HelpNobody') : getRiderName(racer.helpsRacer)}
                                onSelect={(newHelpRacer, e) => helpRacer(racer, newHelpRacer)}>
                                <Dropdown.Item eventKey="0">{getLocalizedText('referenceData', 'HelpNobody')}</Dropdown.Item>
                                {raceEdition.groups[0].racers.slice()
                                  .filter(helpRacer => isOwnRacer(helpRacer))
                                  .filter(helpRacer => helpRacer.id !== racer.id)
                                  .sort(function (a, b) { return a.number - b.number })
                                  .map((helpRacer) => (
                                    <Dropdown.Item eventKey={helpRacer.id}>
                                      {helpRacer.number + ' ' + helpRacer.rider.firstNames.charAt(0) + '. ' + helpRacer.rider.lastNames}
                                    </Dropdown.Item>
                                  )
                                  )}
                              </DropdownButton>
                              <Button size="sm" variant="outline-danger py-0 px-1" onClick={() => helpRacer(racer, 0)}>x</Button>
                            </ButtonGroup>
                          </td>
                          <td>
                            <ButtonGroup>

                              <DropdownButton variant="outline-secondary py-0 px-1"
                                size="sm"
                                title={(racer.followsRacer === 0) ? getLocalizedText('referenceData', 'FollowNobody') : getRiderName(racer.followsRacer)}
                                onSelect={(newFollowedRacer, e) => followRacer(racer, newFollowedRacer)}>
                                <Dropdown.Item eventKey="0">{getLocalizedText('referenceData', 'FollowNobody')}</Dropdown.Item>
                                {raceEdition.groups[0].racers.slice()
                                  .filter(followRacer => !isOwnRacer(followRacer))
                                  .sort(function (a, b) { return a.number - b.number })
                                  .map((followRacer) => (
                                    <Dropdown.Item eventKey={followRacer.id}>
                                      {followRacer.number + ' ' + followRacer.rider.firstNames.charAt(0) + '. ' + followRacer.rider.lastNames + '(' + followRacer.racerTeamName + ')'}
                                    </Dropdown.Item>
                                  )
                                  )}
                              </DropdownButton>
                              <Button size="sm" variant="outline-danger py-0 px-1" onClick={() => followRacer(racer, 0)}>x</Button>
                            </ButtonGroup>
                          </td>
                          <td>
                            {(() => {
                              if (currentStage.raceType === 'Regular') {
                                if (racer.endurance === 'Fighting') {
                                  return <Button size="sm" variant="info py-0 px-2" onClick={() => setEndurance(racer, 'KeepingUp')}>yes</Button>
                                }
                                else {
                                  return <Button size="sm" variant="outline-info py-0 px-2" onClick={() => setEndurance(racer, 'Fighting')}>no</Button>
                                }
                              }
                              else {
                                if (racer.endurance === 'Fighting') {
                                  return <Button size="sm" variant="info py-0 px-2" disabled>yes</Button>
                                }
                                else {
                                  return <Button size="sm" variant="outline-info py-0 px-2" disabled>no</Button>
                                }
                              }
                            })()}
                          </td>
                          <td>
                            <ButtonGroup>
                              {(() => {
                                if (raceEdition.sprintStatus !== 'Completed' && currentStage.raceType === 'Regular')
                                  return <>
                                    <DropdownButton variant={(racer.sprintStrategy === 'None') ? 'outline-secondary py-0 px-1' : 'secondary py-0 px-1'}
                                      size="sm"
                                      title={getLocalizedText('referenceData', 'SprintStrategy' + racer.sprintStrategy)}
                                      onSelect={(newSprintStrategy, e) => setSprint(racer, newSprintStrategy)}>
                                      {['Lose', 'None', 'Follow', 'Launch', 'From450', 'From400', 'From350',
                                        'From300', 'From250', 'From200', 'From150', 'From100', 'From50'].map((sprintStrategy) => {
                                          if (racer.sprintStrategy === sprintStrategy)
                                            return <Dropdown.Item active eventKey={sprintStrategy}>{getLocalizedText('referenceData', 'SprintStrategy' + sprintStrategy)}</Dropdown.Item>
                                          else
                                            return <Dropdown.Item eventKey={sprintStrategy}>{getLocalizedText('referenceData', 'SprintStrategy' + sprintStrategy)}</Dropdown.Item>
                                        })}
                                    </DropdownButton>
                                    <Button size="sm" variant="outline-danger py-0 px-1" onClick={() => setSprint(racer, 'None')}>x</Button>
                                  </>
                                else
                                  return <>
                                    <DropdownButton variant={'outline-secondary py-0 px-1'} size="sm" title={'None'} disabled />
                                    <Button size="sm" variant="outline-danger py-0 px-1" disabled>x</Button>
                                  </>
                              })()}
                            </ButtonGroup>
                          </td>
                          <td>{racer.rider.formCurrent} {((racer.rider.formTendency > 0) ? '+' : ((racer.rider.formTendency == 0) ? '' : '-'))}</td>
                          {(() => {
                            if (isOwnRacer(racer)) {
                              if (racer.energySectorEnd > 8000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 156, 34, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              if (racer.energySectorEnd > 6000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 114, 184, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              if (racer.energySectorEnd > 4000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 149, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              if (racer.energySectorEnd > 2000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 83, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              else {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(203, 6, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                            } else {
                              return <td className="td-race"></td>
                            }
                          })()}
                        </tr>
                      ))}
                  </tbody>
                </Table>
                <Table striped size="sm" className={tab === "moretactics" ? 'mt-0' : 'hidden'}>
                  <thead>
                    <tr className="table-secondary">
                      <th className="th-race" scope="col">#</th>
                      <th className="th-race" scope="col">Rider</th>
                      <th className="th-race" scope="col">Tempo</th>
                      <th className="th-race" scope="col">Action</th>
                      <th className="th-race" scope="col">Until</th>
                      <th className="th-race" scope="col">Set From (incl. km)</th>
                      <th className="th-race" scope="col">Set Until (excl. km)</th>
                      <th className="th-race" scope="col">Attack</th>
                      <th className="th-race" scope="col">Energy</th>
                    </tr>
                  </thead>
                  <tbody>
                    {raceEdition.groups[0].racers.slice()
                      .filter(racer => isOwnRacer(racer))
                      .sort(function (a, b) { return a.number - b.number })
                      .map((racer, index) => (
                        <tr>
                          <td>{racer.number}</td>
                          <td >
                            <a href="#" onClick={() => showRiderInfo(racer.rider)} style={{ color: '#000000' }}>
                              {racer.rider.firstNames} {racer.rider.lastNames}
                            </a>
                          </td>
                          <td>
                            <ButtonGroup >
                              {(() => {
                                if (raceEdition.sprintStatus === 'Completed')
                                  return <>
                                    <DropdownButton size="sm" variant={'outline-secondary py-0 px-1'} title='None' disabled />
                                    <Button size="sm" variant="outline-danger py-0 px-1" disabled>x</Button>
                                  </>
                                else
                                  return <>
                                    <DropdownButton size="sm" variant={(racer.tempoStrategy === 'None') ? 'outline-secondary py-0 px-1' : 'secondary py-0 px-1'}
                                      title={getLocalizedText('referenceData', 'TempoStrategy' + racer.tempoStrategy)}
                                      onSelect={(newTempoStrategy, e) => setTempo(racer, newTempoStrategy, 'None', 'Indefinite')}>
                                      {['None', 'Normal', 'Alone', 'Shared'].map((tempoStrategy) => {
                                        if (racer.tempoStrategy === tempoStrategy)
                                          return <Dropdown.Item active eventKey={tempoStrategy}>{getLocalizedText('referenceData', 'TempoStrategy' + tempoStrategy)}</Dropdown.Item>
                                        else
                                          return <Dropdown.Item eventKey={tempoStrategy}>{getLocalizedText('referenceData', 'TempoStrategy' + tempoStrategy)}</Dropdown.Item>

                                      })}
                                    </DropdownButton>
                                    <Button size="sm" variant="outline-danger py-0 px-1" onClick={() => setTempo(racer, 'None', 'None', 'Indefinite')}>x</Button>
                                  </>
                              })()}
                            </ButtonGroup>
                          </td>
                          <td>
                            {(() => {
                              if (raceEdition.sprintStatus === 'Completed')
                                return <DropdownButton variant={'outline-secondary py-0 px-1'} size="sm" title='None' disabled />
                              else
                                return <DropdownButton variant={(racer.tempoAction === 'None') ? 'outline-secondary py-0 px-1' : 'secondary py-0 px-1'}
                                  size="sm"
                                  title={getLocalizedText('referenceData', 'TempoAction' + racer.tempoAction)}
                                  onSelect={(newTempoAction, e) => {
                                    let newTempoUntil = racer.tempoUntil;
                                    if (newTempoAction !== 'StartWhenDropped') newTempoUntil = 'Indefinite';
                                    setTempo(racer, 'None', newTempoAction, newTempoUntil);
                                  }}>
                                  {['None', 'WaitForLeader', 'DropFromGroup', 'StartWhenDropped'].map((tempoAction) => {
                                    if (racer.tempoAction === tempoAction)
                                      return <Dropdown.Item active eventKey={tempoAction}>{getLocalizedText('referenceData', 'TempoAction' + tempoAction)}</Dropdown.Item>
                                    else
                                      return <Dropdown.Item eventKey={tempoAction}>{getLocalizedText('referenceData', 'TempoAction' + tempoAction)}</Dropdown.Item>
                                  })}
                                </DropdownButton>
                            })()}
                          </td>
                          <td>
                            {(() => {
                              if (raceEdition.sprintStatus === 'Completed')
                                return <DropdownButton variant={'outline-secondary py-0 px-1'} size="sm" title={getLocalizedText('referenceData', 'TempoUntilIndefinite')} disabled />
                              else if (racer.tempoAction === 'DropFromGroup' ||
                                racer.tempoAction === 'WaitForLeader' ||
                                (racer.tempoStrategy === 'None' && racer.tempoAction === 'None'))
                                return <DropdownButton variant={'outline-secondary py-0 px-1'} size="sm" title={getLocalizedText('referenceData', 'TempoUntil' + racer.tempoUntil)} disabled />
                              else
                                return <DropdownButton variant={(racer.tempoUntil === 'Indefinite') ? 'outline-secondary py-0 px-1' : 'secondary py-0 px-1'}
                                  size="sm"
                                  title={getLocalizedText('referenceData', 'TempoUntil' + racer.tempoUntil)}
                                  onSelect={(newTempoUntil, e) => {
                                    let newTempoStrategy = racer.tempoStrategy;
                                    if (racer.tempoStrategy === 'Shared' || racer.tempoStrategy === 'Alone')
                                      newTempoStrategy = 'Normal';
                                    setTempo(racer, newTempoStrategy, racer.tempoAction, newTempoUntil)
                                  }}>
                                  {['Indefinite', 'Dropped', 'ReachPeloton', 'ReachFront'].map((tempoUntil) => {
                                    if (racer.tempoUntil === tempoUntil)
                                      return <Dropdown.Item active eventKey={tempoUntil}>{getLocalizedText('referenceData', 'TempoUntil' + tempoUntil)}</Dropdown.Item>
                                    else
                                      return <Dropdown.Item eventKey={tempoUntil}>{getLocalizedText('referenceData', 'TempoUntil' + tempoUntil)}</Dropdown.Item>
                                  })}
                                </DropdownButton>
                            })()}
                          </td>
                          <td>
                            <InputGroup>
                              <Form.Control
                                size="sm"
                                onChange=
                                {function (e) {
                                  let tempoSettingsLocal = []
                                  tempoSettings.map(ts => {
                                    tempoSettingsLocal.push(
                                      (ts.riderId === racer.rider.id) ?
                                        { riderId: ts.riderId, tempoStartAt: e.target.value, tempoStopAt: ts.tempoStopAt, attackAt: ts.attackAt } : ts)
                                  })
                                  setTempoSettings(tempoSettingsLocal);
                                }}
                                onKeyPress={(e) => (e.key === 'Enter') ? tempoStartAt(
                                  racer, tempoSettings.find(e => e.riderId === racer.rider.id).tempoStartAt) : null}
                                value={tempoSettings.find(e => e.riderId === racer.rider.id).tempoStartAt}
                              />
                              <Button size="sm" variant={'outline-success'}
                                onClick={() => tempoStartAt(racer, tempoSettings.find(e => e.riderId === racer.rider.id).tempoStartAt)}
                              >set</Button>
                              <Button size="sm" variant={'danger'}
                                onClick={() => tempoStartAt(racer, 0)}
                              >x</Button>
                            </InputGroup>
                          </td>
                          <td>
                            <InputGroup>
                              <Form.Control
                                size="sm"
                                onChange=
                                {function (e) {
                                  let tempoSettingsLocal = []
                                  tempoSettings.map(ts => {
                                    tempoSettingsLocal.push(
                                      (ts.riderId === racer.rider.id) ?
                                        { riderId: ts.riderId, tempoStartAt: ts.tempoStartAt, tempoStopAt: e.target.value, attackAt: ts.attackAt } : ts)
                                  })
                                  setTempoSettings(tempoSettingsLocal);
                                }}
                                onKeyPress={(e) => (e.key === 'Enter') ? tempoStopAt(
                                  racer, tempoSettings.find(e => e.riderId === racer.rider.id).tempoStopAt) : null}
                                value={tempoSettings.find(e => e.riderId === racer.rider.id).tempoStopAt}
                              />
                              <Button size="sm" variant={'outline-success'}
                                onClick={() => tempoStopAt(racer, tempoSettings.find(e => e.riderId === racer.rider.id).tempoStopAt)}
                              >set</Button>
                              <Button size="sm" variant={'danger'}
                                onClick={() => tempoStopAt(racer, 0)}
                              >x</Button>
                            </InputGroup>
                          </td>
                          <td>
                            <InputGroup>
                              <Form.Control
                                size="sm"
                                onChange=
                                {function (e) {
                                  let tempoSettingsLocal = []
                                  tempoSettings.map(ts => {
                                    tempoSettingsLocal.push(
                                      (ts.riderId === racer.rider.id) ?
                                        { riderId: ts.riderId, tempoStartAt: ts.tempoStartAt, tempoStopAt: ts.tempoStopAt, attackAt: e.target.value } : ts)
                                  })
                                  setTempoSettings(tempoSettingsLocal);
                                }}
                                onKeyPress={(e) => (e.key === 'Enter') ? attackAt(
                                  racer, tempoSettings.find(e => e.riderId === racer.rider.id).attackAt) : null}
                                value={tempoSettings.find(e => e.riderId === racer.rider.id).attackAt}
                              />
                              <Button size="sm" variant={'outline-success'}
                                onClick={() => attackAt(racer, tempoSettings.find(e => e.riderId === racer.rider.id).attackAt)}
                              >set</Button>
                              <Button size="sm" variant={'danger'}
                                onClick={() => attackAt(racer, 0)}
                              >x</Button>
                            </InputGroup>
                          </td>
                          {(() => {
                            if (isOwnRacer(racer)) {
                              if (racer.energySectorEnd > 8000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 156, 34, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              if (racer.energySectorEnd > 6000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 114, 184, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              if (racer.energySectorEnd > 4000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 149, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              if (racer.energySectorEnd > 2000) {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 83, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                              else {
                                return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(203, 6, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                              }
                            } else {
                              return <td className="td-race"></td>
                            }
                          })()}
                        </tr>
                      ))}
                  </tbody>
                </Table>
                <Table size="sm" className={(tab === "gc" || tab === "points" || tab === "mountain" || tab === "young") ? 'mt-0' : 'hidden'}>
                  <thead>
                    <tr className="table-secondary">
                      <th className="th-race" style={{ paddingRight: "5px" }}>{((GCSortBy === 'gc' && tab === "gc") || (GCSortBy === 'points' && tab === "points") || (GCSortBy === 'mountain' && tab === "mountain") || (GCSortBy === 'gc' && tab === "young")) ? 'Rank' : 'Nr'}</th>
                      <th onClick={() => handleGCSorting('flag', tab)} className="th-race sortable">⚑</th>
                      <th onClick={() => handleGCSorting('lastNames', tab)} className="th-race sortable" style={{ textAlign: "left" }}>Rider</th>
                      <th onClick={() => handleGCSorting('team', tab)} className="th-race sortable" style={{ textAlign: "left" }}>Team</th>
                      <th onClick={() => handleGCSorting('climbing', tab)} className="th-race sortable" scope="col"><img src={SkillClimbing} title="Mountain" alt="Climbing" /></th>
                      <th onClick={() => handleGCSorting('flat', tab)} className="th-race sortable" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                      <th onClick={() => handleGCSorting('downhill', tab)} className="th-race sortable" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                      <th onClick={() => handleGCSorting('timeTrial', tab)} className="th-race sortable" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                      <th onClick={() => handleGCSorting('sprint', tab)} className="th-race sortable" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                      <th onClick={() => handleGCSorting('pave', tab)} className="th-race sortable" scope="col"><img src={SkillCobbles} title="Cobbles" alt="Cobbles" /></th>
                      <th onClick={() => handleGCSorting('reg', tab)} className="th-race sortable" scope="col"><img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /></th>
                      <th onClick={() => handleGCSorting('age', tab)} className="th-race sortable" scope="col">Age</th>
                      <th onClick={() => handleGCSorting('gc', tab)} className={(raceEdition.race.numberOfStages > 1) ? 'th-race sortable' : 'th-race-hidden'} scope="col" style={{ textAlign: "right", paddingRight: 10 }}>GC</th>
                      <th onClick={() => handleGCSorting('virtual', tab)} className="th-race sortable" scope="col" style={{ textAlign: "right", paddingRight: 10 }}>Virtual</th>
                      <th onClick={() => handleGCSorting('points', tab)} className="th-race sortable" scope="col" style={{ textAlign: "right", paddingRight: 5 }}>Points</th>
                      <th onClick={() => handleGCSorting('mountain', tab)} className="th-race sortable" scope="col" style={{ textAlign: "right", paddingRight: 5 }}>Mountain</th>
                    </tr>
                  </thead>
                  <tbody>
                    {raceEdition.groups[0].racers.slice()
                      .map((racer) => ({ ...racer, ownRider: isOwnRacer(racer) }))
                      .filter(racer => racer.rider.age <= findAgeLimit(tab))
                      .sort(function (a, b) {
                        switch (GCSortBy + ';' + GCSortOrder) {
                          case 'number;desc': return a.number - b.number;
                          case 'number;asc': return b.number - a.number;
                          case 'flag;desc': return a.rider.nationality.localeCompare(b.rider.nationality);
                          case 'flag;asc': return b.rider.nationality.localeCompare(a.rider.nationality);
                          case 'lastNames;desc': return a.rider.lastNames.localeCompare(b.rider.lastNames)
                            || a.rider.firstNames.localeCompare(b.rider.firstNames);
                          case 'lastNames;asc': return b.rider.lastNames.localeCompare(a.rider.lastNames)
                            || b.rider.firstNames.localeCompare(a.rider.firstNames);
                          case 'team;desc': return a.racerTeamName.localeCompare(b.racerTeamName);
                          case 'team;asc': return b.racerTeamName.localeCompare(a.racerTeamName);
                          case 'climbing;asc': return a.rider.skills.Climbing - b.rider.skills.Climbing;
                          case 'climbing;desc': return b.rider.skills.Climbing - a.rider.skills.Climbing;
                          case 'flat;asc': return a.rider.skills.Flat - b.rider.skills.Flat;
                          case 'flat;desc': return b.rider.skills.Flat - a.rider.skills.Flat;
                          case 'downhill;asc': return a.rider.skills.Downhill - b.rider.skills.Downhill;
                          case 'downhill;desc': return b.rider.skills.Downhill - a.rider.skills.Downhill;
                          case 'timeTrial;asc': return a.rider.skills.TimeTrial - b.rider.skills.TimeTrial;
                          case 'timeTrial;desc': return b.rider.skills.TimeTrial - a.rider.skills.TimeTrial;
                          case 'sprint;asc': return a.rider.skills.Sprint - b.rider.skills.Sprint;
                          case 'sprint;desc': return b.rider.skills.Sprint - a.rider.skills.Sprint;
                          case 'pave;asc': return (a.rider.skills.Cobbles * 0.3 + a.rider.skills.Flat * 0.7) - (b.rider.skills.Cobbles * 0.3 + b.rider.skills.Flat * 0.7);
                          case 'pave;desc': return (b.rider.skills.Cobbles * 0.3 + b.rider.skills.Flat * 0.7) - (a.rider.skills.Cobbles * 0.3 + a.rider.skills.Flat * 0.7);
                          case 'reg;asc': return a.rider.skills.Regeneration - b.rider.skills.Regeneration;
                          case 'reg;desc': return b.rider.skills.Regeneration - a.rider.skills.Regeneration;
                          case 'age;asc': return a.rider.age - b.rider.age;
                          case 'age;desc': return b.rider.age - a.rider.age;
                          case 'gc;asc': return a.gapOverall - b.gapOverall
                            || b.sprintPoints - a.sprintPoints
                            || b.mountainPoints - a.mountainPoints;
                          case 'gc;desc': return b.gapOverall - a.gapOverall
                            || b.sprintPoints - a.sprintPoints
                            || b.mountainPoints - a.mountainPoints;
                          case 'virtual;asc': return a.gapOverallVirtual - b.gapOverallVirtual
                            || b.sprintPoints - a.sprintPoints
                            || b.mountainPoints - a.mountainPoints;
                          case 'virtual;desc': return b.gapOverallVirtual - a.gapOverallVirtual
                            || b.sprintPoints - a.sprintPoints
                            || b.mountainPoints - a.mountainPoints;
                          case 'points;asc': return a.sprintPoints - b.sprintPoints
                            || a.gapOverall - b.gapOverall
                            || b.mountainPoints - a.mountainPoints
                          case 'points;desc': return b.sprintPoints - a.sprintPoints
                            || a.gapOverall - b.gapOverall
                            || b.mountainPoints - a.mountainPoints
                          case 'mountain;asc': return a.mountainPoints - b.mountainPoints
                            || a.gapOverall - b.gapOverall
                            || b.sprintPoints - a.sprintPoints
                          case 'mountain;desc': return b.mountainPoints - a.mountainPoints
                            || a.gapOverall - b.gapOverall
                            || b.sprintPoints - a.sprintPoints
                          default: return a.gapOverall - b.gapOverall
                            || b.sprintPoints - a.sprintPoints
                            || b.mountainPoints - a.mountainPoints;
                        }
                      })
                      .map((racer, index) =>
                        <tr>
                          <td className="td-race">{((GCSortBy === 'gc' && tab === "gc") || (GCSortBy === 'points' && tab === "points") || (GCSortBy === 'mountain' && tab === "mountain") || (GCSortBy === 'gc' && tab === "young")) ? index + 1 : racer.number}</td>
                          <td className="td-race">{getUnicodeOrImageFlag(countries, racer.rider.nationality, browserInfo)}</td>
                          <td className="td-race"
                            onClick={() => showRiderInfo(racer.rider)}
                            style={(isOwnRacer(racer)) ? { fontWeight: "bold", textAlign: "left", cursor: "pointer" } : { textAlign: "left", cursor: "pointer" }}>
                            <a href="#" onClick={() => showRiderInfo(racer.rider)} style={{ color: '#000000' }}>
                              {racer.rider.firstNames} {racer.rider.lastNames}
                            </a>
                            {racer.rider.jerseys.map(jersey => (
                              <img alt={jersey} title={jersey} src={getJersey('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName, jersey)} style={{ maxHeight: "18px" }} />
                            ))}
                            {racer.raceJersey !== 'None' ?
                              <img alt={racer.raceJersey} title={racer.raceJersey} 
                              src={getJersey('recurringEvent' in raceEdition.race ? raceEdition.race.recurringEvent : raceEdition.race.raceName, racer.raceJersey)} style={{ maxHeight: "18px" }} />
                              : null }
                          </td>
                          <td className="td-race"
                            style={(isOwnRacer(racer)) ? { fontWeight: "bold", textAlign: "left" } : { textAlign: "left" }}>
                            <a href="#" onClick={() => showTeamInfo(getTeamByRacerTeamId(racer.racerTeamId))}
                              style={{ color: "black" }}>{(racer.racerTeamName.length > 20) ? (racer.racerTeamName.substr(0, 17) + '...') : racer.racerTeamName}
                            </a>
                          </td>
                          <td className="td-race">{racer.rider.skills.Climbing}</td>
                          <td className="td-race">{racer.rider.skills.Flat}</td>
                          <td className="td-race">{racer.rider.skills.Downhill}</td>
                          <td className="td-race">{racer.rider.skills.TimeTrial}</td>
                          <td className="td-race">{racer.rider.skills.Sprint}</td>
                          <td className="td-race">{Math.round((racer.rider.skills.Cobbles * 0.3 + racer.rider.skills.Flat * 0.7) * 10) / 10}</td>
                          <td className="td-race">{racer.rider.skills.Regeneration}</td>
                          <td className="td-race">{racer.rider.age}</td>
                          <td className={(raceEdition.race.numberOfStages > 1) ? 'td-race' : 'td-race-hidden'} style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapOverall)}</td>
                          <td className="td-race" style={{ textAlign: "right", paddingRight: 5 }}>{formatTimeSeconds(racer.gapOverallVirtual)}</td>
                          <td className="td-race" style={{ textAlign: "right", paddingRight: 5 }}>{racer.sprintPoints}</td>
                          <td className="td-race" style={{ textAlign: "right", paddingRight: 5 }}>{racer.mountainPoints}</td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>

                {tab === 'team' ?
                <>
                  <C4FSimpleTable
                    initialSortingColumn={raceEdition.race.numberOfStages > 1 ? 'teamClassification' : 'division'}
                    initialSortingAscending={true}
                    hideFilterButtons={true}
                    hideColumnVisibility={true}
                    indexColumn={true}
                    data={raceEdition.teams.map(t => ({
                      ...t,
                      teamId: t.team.id,
                      teamName: t.team.teamName,
                      teamAcronym: t.team.acronym,
                      languageFlag: getUnicodeFlag(t.team.ownerLanguage === 'EN' ? 'GB' : t.team.ownerLanguage),
                      languageC4fCode: getC4FCodeForCountryCode(countries, t.team.ownerLanguage === 'EN' ? 'GB' : t.team.ownerLanguage),
                      division: t.team.division,
                      pointsCurrent: t.team.pointsCurrent,
                      eternalPoints: t.team.pointsEternal,
                      offlineDays: t.offlineDays + (t.offlineToday === 'True' ? 1 : 0),
                      totalRaces: t.team.totalRaces,
                      teamClassification: formatTimeSeconds(t.teamClassification)
                    }))}
                    rowMetadata={
                      []
                        .concat([
                          { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                          { columnName: 'teamAcronym', columnDescription: 'Acronym' }
                        ])
                        .concat([
                          browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                            { columnName: 'languageFlag', columnDescription: '\u2691' }
                            :
                            { columnName: 'languageC4fCode', columnDescription: '\u2691', columnType: 'flag' }])
                        .concat([
                          { columnName: 'division', columnDescription: 'Division' },
                          { columnName: 'pointsCurrent', columnDescription: 'Points' },
                          { columnName: 'eternalPoints', columnDescription: 'Eternal' },
                          { columnName: 'totalRaces', columnDescription: 'Races' },
                          { columnName: 'salary', columnDescription: 'Salary', columnType: 'currency' }
                        ])
                        .concat(raceEdition.race.numberOfStages > 1 ?
                          [
                            { columnName: 'offlineDays', columnDescription: 'Off Days' },
                            { columnName: 'teamClassification', columnDescription: 'Time' }
                          ] : [])
                    }
                  />
                  <Button className={'mx-1'} variant={'outline-secondary'} size="sm" onClick={() => handleShowFinances()}>{getLocalizedText('race', 'ButtonFinanceDetails')}</Button>
                  </>
                  : null}

                {tab === 'voting' ? <>
                  {typeof raceEdition.teams.find(racerTeam => racerTeam.team.teamName === controlledTeam && racerTeam.fairplayVotesCast === false) !== 'undefined' ?
                    <>
                      <Col className="mt-1">
                        <h4>Most Combative Rider</h4>
                        <DropdownButton variant="outline-primary"
                          size="sm"
                          title={(mostActiveRiderVote === 0) ? 'Please choose' : getRiderFullName(mostActiveRiderVote)}
                          onSelect={(newMostActiveRiderVote, e) => setMostActiveRiderVote(parseInt(newMostActiveRiderVote))}>
                          <Dropdown.Item eventKey="0">Please choose</Dropdown.Item>
                          {raceEdition.groups[0].racers.slice()
                            .filter(racer => !isOwnRacer(racer))
                            .filter(racer => racer.raceJersey === 'None')
                            .sort(function (a, b) {
                              return a.number - b.number
                            })
                            .map((racer) => (
                              <Dropdown.Item eventKey={racer.id}>
                                {racer.number + ' ' + racer.rider.firstNames.charAt(0) + '. ' + racer.rider.lastNames + '(' + racer.racerTeamName + ')'}
                              </Dropdown.Item>
                            )
                            )}
                        </DropdownButton>
                        <h4>Fairplay Votes</h4>
                        <Container>
                          {raceEdition.teams
                            .filter(racerTeam => racerTeam.team.teamName !== controlledTeam)
                            .map((racerTeam) =>
                              <>
                                <Form.Label className="mt-1">{racerTeam.team.teamName}</Form.Label><br></br>
                                <ButtonGroup className="mt-1">
                                  {[-3, -2, -1, 0, 1, 2, 3].map(points =>
                                    <Button size="sm" variant={voting.find(voting => voting.racerTeamId === racerTeam.id).vote === points ? 'primary' : 'outline-primary'}
                                      onClick={() => handleVoting(racerTeam, 'vote', points)}>{points}</Button>)}
                                </ButtonGroup>
                                <Form.Control size="sm" className="mt-1" type="text"
                                  onChange={(e) => (e.target.value.length <= 100) ? handleVoting(racerTeam, 'message', e.target.value) : null}
                                  placeholder="message"
                                  value={voting.find(voting => voting.racerTeamId === racerTeam.id).message} />
                              </>
                            )}
                        </Container>
                        <Button className="mt-1" size="sm" variant="primary" onClick={() => handleSubmitVoting()}>Submit</Button>
                        <Alert className="mt-1" key="alertvotes" variant={'danger'}>{votingInfo}</Alert>
                      </Col>
                    </>
                    :
                    <C4FSimpleTable
                      hideFilterButtons={true}
                      hideColumnVisibility={true}
                      data={raceEdition.fairplayVotes
                        .map((fairplayVote, index) => ({ ...fairplayVote, position: index + 1 }))}
                      rowMetadata={[
                        { columnName: 'date', columnDescription: 'Date' },
                        { columnName: 'fromTeam', columnDescription: 'From', cellClickEvent: handleShowFromTeamInfo },
                        { columnName: 'toTeam', columnDescription: 'To', cellClickEvent: handleShowToTeamInfo },
                        { columnName: 'vote', columnDescription: 'Vote', columnType: 'fairplayVote' },
                        { columnName: 'message', columnDescription: 'Message' }
                      ]} />
                  }
                </>
                  : null}
                {tab === 'interviews' ? <>
                  {userInterviewRequest !== 'None' && userInterview ?
                    <Col className="mt-1">
                      <h4>{userInterviewRequest.startsWith('PreRace') ? 'Pre Race' : 'Winner'} Interview with {userInformation.userName}</h4>
                      <Form.Label className="mt-1">{userInterview.items[0].question}</Form.Label><br></br>
                      <Form.Control size="sm" className="mt-1" type="text"
                        onChange={(e) => setUserInterviewAnswer1(e.target.value)}
                        placeholder="answer"
                        value={userInterviewAnswer1} />
                      <Form.Label className="mt-1">{userInterview.items[1].question}</Form.Label><br></br>
                      <Form.Control size="sm" className="mt-1" type="text"
                        onChange={(e) => setUserInterviewAnswer2(e.target.value)}
                        placeholder="answer"
                        value={userInterviewAnswer2} />
                      <Form.Label className="mt-1">{userInterview.items[2].question}</Form.Label><br></br>
                      <Form.Control size="sm" className="mt-1" type="text"
                        onChange={(e) => setUserInterviewAnswer3(e.target.value)}
                        placeholder="answer"
                        value={userInterviewAnswer3} />
                      <Button className="mt-1" size="sm" variant="primary" onClick={() => saveInterview(false)}>Submit</Button>
                      <Button className="mx-1 mt-1" size="sm" variant="primary" onClick={() => saveInterview(true)}>Skip</Button>
                      <Alert className="mt-1" key="alertinterviews" variant={'danger'}>{userInterviewInfo}</Alert>
                    </Col>
                    :
                    <Col className="mt-1">
                      {interviews.map(interview =>
                        <>
                          <h4>{interview.type.startsWith('PreRace') ? 'Pre Race' : 'Winner'} Interview with {interview.teamName} ({interview.time})</h4>
                          {interview.items.map(interviewItem =>
                            <>
                              <b>{interviewItem.question}</b><br></br>
                              {interviewItem.answer}<br></br>
                            </>)}
                        </>)}
                    </Col>
                  }
                </>
                  : null}
              </Row>)
            :
            (
              <Row className="mt-2 border border-secondary p-0" style={{ fontSize: "0.875em" }}>
                <div className="col p-0 m-0">
                  <div className="row d-flex justify-content-left m-0 p-1" style={{ overflowX: 'auto', marginLeft: 'auto', marginRight: 'auto', maxHeight: 80, backgroundColor: "rgba(245, 250, 255, 1)" }}>
                    <b>Sprint Groups:&nbsp;</b>
                    <ButtonGroup>
                      {raceEdition.groups[0].racers.slice()
                        .map(racer => racer.gapCurrentStage)
                        .sort(function (a, b) { return a - b })
                        .filter((value, index, self) => self.indexOf(value) === index)
                        .map((group, index) => {
                          let currentGroup = raceEdition.groups[0].racers.slice().filter(racer => racer.gapCurrentStage === group);
                          let sprinters = currentGroup.find(racer => racer.positionX > 0);
                          let ownRacers = currentGroup.find(racer => isOwnRacer(racer));
                          let hasSprinters = typeof sprinters !== 'undefined';
                          let hasOwnRacers = typeof ownRacers !== 'undefined';
                          if (hasSprinters && hasOwnRacers)
                            return <Button size="sm" onClick={() => setSprintGroup(group)}
                              variant={(sprintGroup === group) ? 'primary py-0' : 'outline-primary py-0'}>
                              {formatTimeSeconds(group)}
                            </Button>
                          if (hasSprinters && !hasOwnRacers)
                            return <Button size="sm" onClick={() => setSprintGroup(group)}
                              variant={(sprintGroup === group) ? 'secondary py-0' : 'outline-secondary py-0'}>
                              {formatTimeSeconds(group)}
                            </Button>
                          if (!hasSprinters)
                            return <Button size="sm" disabled
                              variant={'outline-secondary py-0'}>
                              {formatTimeSeconds(group)}
                            </Button>
                        })}
                    </ButtonGroup>
                  </div>
                  <div className="row d-flex justify-content-left m-0 p-0" style={{ minHeight: 150, maxHeight: 250, backgroundColor: "rgba(251, 253, 255, 1)", overflowY: "visible", overflowX: "auto" }}>
                    {(() => {
                      if (raceEdition.sprintStatus !== 'Completed')
                        return <Table className="table table-light table-striped table-hover mt-0 " size="sm">
                          <thead>
                            <tr className="table-secondary">
                              <th className="th-race" scope="col" style={{ textAlign: "left" }}>Rider</th>
                              <th className="th-race" scope="col" style={{ textAlign: "left" }}>Sprint</th>
                              <th className="th-race" scope="col" style={{ textAlign: "left" }}>Sprint From</th>
                              <th className="th-race" scope="col" style={{ textAlign: "left" }}>Follow</th>
                              <th className="th-race" scope="col">Energy</th>
                            </tr>
                          </thead>
                          <tbody>
                            {raceEdition.groups[0].racers.slice()
                              .filter(racer =>
                                isOwnRacer(racer) &&
                                racer.positionX > 0 &&
                                racer.positionY < 10 &&
                                racer.gapCurrentStage === sprintGroup)
                              .map((racer, index) => (
                                <tr>
                                  <td className="td-race" style={{ textAlign: "left" }}>{racer.rider.firstNames}&nbsp;{racer.rider.lastNames}</td>
                                  <td className="td-race" style={{ textAlign: "left" }}>
                                    <ButtonGroup>
                                      <Button size="sm" onClick={() => setSprint(racer, 'Lose')} variant={(racer.sprintStrategy === 'Lose') ? 'danger py-0' : 'outline-danger py-0'}>{getLocalizedText('referenceData', 'SprintStrategyLose')}</Button>
                                      <Button size="sm" onClick={() => setSprint(racer, 'Follow')} variant={(racer.sprintStrategy === 'Follow') ? 'secondary py-0' : 'outline-secondary py-0'}>{getLocalizedText('referenceData', 'SprintStrategyFollow')}</Button>
                                      <Button size="sm" onClick={() => setSprint(racer, 'SprintLeft')} variant={(racer.sprintStrategy === 'SprintLeft') ? 'success py-0' : 'outline-success py-0'}>{getLocalizedText('referenceData', 'SprintStrategySprintLeft')}</Button>
                                      <Button size="sm" onClick={() => setSprint(racer, 'SprintRight')} variant={(racer.sprintStrategy === 'SprintRight') ? 'success py-0' : 'outline-success py-0'}>{getLocalizedText('referenceData', 'SprintStrategySprintRight')}</Button>
                                    </ButtonGroup>
                                  </td>
                                  <td className="td-race" style={{ textAlign: "left" }}>
                                    <DropdownButton variant={(racer.sprintStrategy.match('From.+')) ? 'secondary py-0' : 'outline-secondary py-0'}
                                      size="sm"
                                      title={(racer.sprintStrategy.match('From.+')) ? getLocalizedText('referenceData', 'SprintStrategy' + racer.sprintStrategy) : 'SprintFrom'}
                                      onSelect={(newSprintStrategy, e) => setSprint(racer, newSprintStrategy)}>
                                      {['From450', 'From400', 'From350', 'From300', 'From250',
                                        'From200', 'From150', 'From100', 'From50'].map((sprintStrategy) => {
                                          if (racer.sprintStrategy === sprintStrategy)
                                            return <Dropdown.Item className="narrow-dropdown" active eventKey={sprintStrategy}>{getLocalizedText('referenceData', 'SprintStrategy' + sprintStrategy)}</Dropdown.Item>
                                          else
                                            return <Dropdown.Item className="narrow-dropdown" eventKey={sprintStrategy}>{getLocalizedText('referenceData', 'SprintStrategy' + sprintStrategy)}</Dropdown.Item>
                                        })}
                                    </DropdownButton>
                                  </td>
                                  <td className="td-race" style={{ textAlign: "left" }}>
                                    <ButtonGroup>
                                      <DropdownButton variant={(racer.followsRacer === 0) ? 'danger py-0' : 'outline-secondary py-0'}
                                        size="sm"
                                        title={(racer.followsRacer === 0) ? 'None' : getRiderNameSprint(racer.followsRacer)}
                                        onSelect={(newFollowedRacer, e) => followRacer(racer, newFollowedRacer)}>
                                        <Dropdown.Item eventKey="0" className="narrow-dropdown">None</Dropdown.Item>
                                        {raceEdition.groups[0].racers.slice()
                                          .filter(followRacer =>
                                            followRacer.positionX > 0 &&
                                            followRacer.gapCurrentStage === sprintGroup &&
                                            followRacer.id !== racer.id)
                                          .sort(function (a, b) { return b.rider.skills.Sprint - a.rider.skills.Sprint })
                                          .map((followRacer, index) => (
                                            <Dropdown.Item flip eventKey={followRacer.id} className="narrow-dropdown">
                                              {followRacer.rider.skills.Sprint + ' ' + followRacer.rider.lastNames + ' (' + followRacer.racerTeamName + ')'}
                                            </Dropdown.Item>
                                          )
                                          )}
                                      </DropdownButton>
                                      <Button size="sm" variant="outline-danger py-0" onClick={() => followRacer(racer, 0)}>x</Button>
                                    </ButtonGroup>
                                  </td>
                                  {(() => {
                                    if (isOwnRacer(racer)) {
                                      if (racer.energySectorEnd > 8000) {
                                        return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 156, 34, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                      }
                                      if (racer.energySectorEnd > 6000) {
                                        return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(0, 114, 184, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                      }
                                      if (racer.energySectorEnd > 4000) {
                                        return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 149, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                      }
                                      if (racer.energySectorEnd > 2000) {
                                        return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(243, 83, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                      }
                                      else {
                                        return <td className="td-race" style={{ fontWeight: "bold", color: "rgba(203, 6, 0, 1)" }}>{parseInt(racer.energySectorEnd / 10)}</td>;
                                      }
                                    } else {
                                      return <td className="td-race"></td>
                                    }
                                  })()}
                                </tr>
                              ))}
                          </tbody>
                        </Table>
                    })()}
                  </div>
                  <div className="row d-flex justify-content-center m-0 p-0" style={{ maxHeight: 50, backgroundColor: "rgba(180, 180, 180, 1)" }}>
                    <b>{(raceEdition.raceLog.substr(19, 50).search('Km:') === -1) ? '450 m' : raceEdition.raceLog.substr(19, 50).substr(raceEdition.raceLog.substr(19, 50).search(':') + 2, raceEdition.raceLog.substr(19, 50).search('Km:') - raceEdition.raceLog.substr(19, 50).search(':') - 3) + ' m'}</b>
                  </div>
                  <div className="row d-flex justify-content-left m-0 p-0" style={{ backgroundColor: "rgba(140, 140, 140, 1)" }}>
                    <div ref={sprintRef} className="m-0 p-0" style={{ overflowX: 'auto', maxHeight: 430, backgroundColor: "rgba(140, 140, 140, 1)", scrollBehavior: 'smooth' }}>
                      <Stage width={Math.max(((sprintPositionXMax - sprintPositionXMin) / 4) + 48, 996)} height={400}>
                        <Layer>
                          <Line points={[0, 196, Math.max(((sprintPositionXMax - sprintPositionXMin) / 4) + 48, 996), 196]} stroke={'white'} strokeWidth={8} dash={[50, 25]} />
                          {
                            raceEdition.groups[0].racers.slice()
                              .filter(racer => racer.positionX > 0 && racer.gapCurrentStage === sprintGroup)
                              .map((racer, index) => (
                                <>
                                  <RiderImage key={racer.id}
                                    url={config.DIR_JERSEYS + getJerseyForRacer(countries, racer, raceEdition.teams.find(t => t.id === racer.racerTeamId).team, raceEdition.race)}
                                    x={(racer.positionX - sprintPositionXMin) / 4 + Math.max(0, (996 - (((sprintPositionXMax - sprintPositionXMin) / 4) + 48)))}
                                    y={(racer.positionY * 50)}
                                    width={48} height={48}
                                    riderName={racer.rider.lastNames.substring(0, 9)}
                                    riderSprint={racer.rider.skills.Sprint}
                                  />
                                   { racer.raceJersey == 'RedLantern' ?
                                  <RiderImage key={racer.id + 'RedLantern'}
                                  url={config.DIR_JERSEYS + 'special/redlantern.png'}
                                  x={(racer.positionX - sprintPositionXMin) / 4 + Math.max(0, (996 - (((sprintPositionXMax - sprintPositionXMin) / 4) + 48)))}
                                  y={(racer.positionY * 50)}
                                  width={48} height={48}
                                  riderName={racer.rider.lastNames.substring(0, 9)}
                                  riderSprint={racer.rider.skills.Sprint}
                                  />
                                  :
                                  <></>
                                  }
                                  { racer.raceJersey == 'MostActive' ?
                                  <RiderImage key={racer.id  + 'MostActive'}
                                  url={config.DIR_JERSEYS + 'special/mostactive.png'}
                                  x={(racer.positionX - sprintPositionXMin) / 4 + Math.max(0, (996 - (((sprintPositionXMax - sprintPositionXMin) / 4) + 48)))}
                                  y={(racer.positionY * 50)}
                                  width={48} height={48}
                                  riderName={racer.rider.lastNames.substring(0, 9)}
                                  riderSprint={racer.rider.skills.Sprint}
                                  />
                                  :
                                  <></>
                                  }                   
                                  {(editRacerTactic === null) ?
                                    ((isOwnRacer(racer)) ?
                                      <Rect
                                        fill={'#ffcd00'}
                                        opacity={0}
                                        x={(racer.positionX - sprintPositionXMin) / 4 + Math.max(0, (996 - (((sprintPositionXMax - sprintPositionXMin) / 4) + 48)))}
                                        y={(racer.positionY * 50)}
                                        width={48} height={50}
                                        onMouseEnter={e => {
                                          const container = e.target.getStage().container();
                                          container.style.cursor = "pointer";
                                          e.target.opacity(0.4);
                                        }}
                                        onMouseLeave={e => {
                                          const container = e.target.getStage().container();
                                          container.style.cursor = "default";
                                          e.target.opacity(0);
                                        }}
                                        onClick={() => {
                                          setEditRacerTactic(racer);
                                        }}
                                        onTap={() => {
                                          setEditRacerTactic(racer);
                                        }}
                                      />
                                      :
                                      <></>
                                    )
                                    :
                                    ((isOwnRacer(racer) && editRacerTactic.id === racer.id) ?
                                      <Rect
                                        fill={'#ffcd00'}
                                        opacity={0.4}
                                        x={(racer.positionX - sprintPositionXMin) / 4 + Math.max(0, (996 - (((sprintPositionXMax - sprintPositionXMin) / 4) + 48)))}
                                        y={(racer.positionY * 50)}
                                        width={48} height={50}
                                        onMouseEnter={e => {
                                          const container = e.target.getStage().container();
                                          container.style.cursor = "pointer";
                                          e.target.opacity(0.6);
                                        }}
                                        onMouseLeave={e => {
                                          const container = e.target.getStage().container();
                                          container.style.cursor = "default";
                                          e.target.opacity(0.4);
                                        }}
                                        onClick={() => {
                                          setEditRacerTactic(null);
                                        }}
                                        onTap={() => {
                                          setEditRacerTactic(null);
                                        }}
                                      />
                                      :
                                      ((racer.id === editRacerTactic.followsRacer) ?
                                        <Rect
                                          fill={'#ff8800'}
                                          opacity={0.55}
                                          x={(racer.positionX - sprintPositionXMin) / 4 + Math.max(0, (996 - (((sprintPositionXMax - sprintPositionXMin) / 4) + 48)))}
                                          y={(racer.positionY * 50)}
                                          width={48} height={50}
                                          onMouseEnter={e => {
                                            const container = e.target.getStage().container();
                                            container.style.cursor = "pointer";
                                            e.target.fill('#ffffff');
                                            e.target.opacity(0.4);
                                          }}
                                          onMouseLeave={e => {
                                            const container = e.target.getStage().container();
                                            container.style.cursor = "default";
                                            e.target.fill('#ffffff');
                                            e.target.opacity(0);
                                          }}
                                          onClick={e => {
                                            e.target.fill('#ffffff');
                                            e.target.opacity(0.7);
                                            followRacer(editRacerTactic, racer.id);
                                          }}
                                          onTap={e => {
                                            e.target.fill('#ffffff');
                                            e.target.opacity(0.7);
                                            followRacer(editRacerTactic, racer.id);
                                          }}
                                        />
                                        :
                                        <Rect
                                          fill={'#ff8800'}
                                          opacity={0}
                                          x={(racer.positionX - sprintPositionXMin) / 4 + Math.max(0, (996 - (((sprintPositionXMax - sprintPositionXMin) / 4) + 48)))}
                                          y={(racer.positionY * 50)}
                                          width={48} height={50}
                                          onMouseEnter={e => {
                                            const container = e.target.getStage().container();
                                            container.style.cursor = "pointer";
                                            e.target.fill('#ffffff');
                                            e.target.opacity(0.4);
                                          }}
                                          onMouseLeave={e => {
                                            const container = e.target.getStage().container();
                                            container.style.cursor = "default";
                                            e.target.fill('#ffffff');
                                            e.target.opacity(0);
                                          }}
                                          onClick={e => {
                                            e.target.fill('#ffffff');
                                            e.target.opacity(0.7);
                                            followRacer(editRacerTactic, racer.id);
                                          }}
                                          onTap={e => {
                                            e.target.fill('#ffffff');
                                            e.target.opacity(0.7);
                                            followRacer(editRacerTactic, racer.id);
                                          }}
                                        />
                                      )
                                    )
                                  }
                                </>
                              ))}
                        </Layer>
                      </Stage>
                    </div>
                  </div>
                </div>
              </Row>
            )}
          <div className="row d-flex my-2 justify-content-center">
            <div className="col border border-secondary mx-0" style={{ height: 150, minWidth: 280, overflow: "auto", backgroundColor: 'rgba(255, 255, 255, 1)' }}>
              {translateRaceLog(raceEdition.raceLog).split('\n').map((item, key) => {
                return <p className="text-justify mt-0 mb-0 px-0 py-0" key={key} style={{ fontSize: "0.8em" }}>{item}<br /></p>
              })}
            </div>
            <div className="col mx-1 justify-content-center">
              <p style={{ textAlign: "center" }}>
                <ButtonGroup>
                  {(!refreshEnabled) ?
                    <>
                      <Button variant="outline-primary" disabled>
                        {getLocalizedText('race', 'ButtonRefresh') + ' \u21BB '}
                        <Countdown key={'refreshTimer'}
                          autostart={false}
                          renderer={({ seconds }) => seconds}
                          onComplete={() => setRefreshEnabled(true)}
                          date={Date.now() + getFlexibleRefreshDelay()} />
                        {' '}
                        {responseStatus === 'ok' ? '\uD83D\uDFE2' : null}
                        {responseStatus === 'pending' ? '\uD83D\uDFE1' : null}
                        {responseStatus === 'failed' ? '\uD83D\uDD34' : null}
                      </Button>
                    </>
                    :
                    (<Button variant={'primary'} onClick={() => handleRefresh()}>
                      {getLocalizedText('race', 'ButtonRefresh') + ' \u21BB 0 '}
                      {responseStatus === 'ok' ? '\uD83D\uDFE2' : null}
                      {responseStatus === 'pending' ? '\uD83D\uDFE1' : null}
                      {responseStatus === 'failed' ? '\uD83D\uDD34' : null}
                    </Button>)}
                  {raceEdition.sprintStatus !== 'Completed' ?
                    <>
                      {autoRefreshEnabled ?
                        <Button variant={'secondary'}
                          onClick={() => setAutoRefreshEnabled((autoRefreshEnabled) ? false : true)}>
                          {getLocalizedText('race', 'ButtonAutoRefresh') + ' \u2699 '}
                          <Countdown key={autoRefreshTimer}
                            renderer={({ seconds }) => { return <span>{seconds}</span>; }}
                            onComplete={() => handleAutoRefresh()}
                            date={Date.now() + userInformation.autoRefreshDelay} />
                        </Button>
                        :
                        <Button variant={'outline-secondary'} disabled={props.userRole !== 'Participant' && isNationalTeamRace(raceEdition.race.eventType)}
                          onClick={() => setAutoRefreshEnabled((autoRefreshEnabled) ? false : true)}>
                          {getLocalizedText('race', 'ButtonAutoRefresh') + ' \u2699'}
                        </Button>
                      }
                    </> : null}
                </ButtonGroup>
                {raceEdition.sprintStatus !== 'NotStarted' || 
                raceEdition.currentSector === 1 && raceEdition.currentStage > 1 || 
                raceEdition.halfStageWaitingTime > 3 ?
                  <Button className={'mx-1'} variant={'secondary'} onClick={() => handleShowReplay()}>{'Replay \u25B6'}</Button>
                  : null}
              </p>
              <p style={{ textAlign: "center" }}>
                <b>{getLocalizedText('race', 'InfoLastRefresh')}:</b><br />
                {lastRefresh.format('LTS')}<br />
                ({getLocalizedText('race', 'InfoLocalTime')})
              </p>
            </div>
          </div>
          <div className="row d-flex my-2 justify-content-center">
            <div className="col border border-secondary mx-0" style={{ height: 300, minWidth: 200, overflow: "auto", backgroundColor: 'rgba(255, 255, 255, 1)' }}>
              <h6>Participants ({raceEdition.onlineStatus.filter(user => user.role === 'Participant').length})</h6>
              {raceEdition.onlineStatus.filter(user => user.role === 'Participant')
                .sort(function (a, b) { return a.teamName.localeCompare(b.teamName); })
                .map(user => 
                <p className="text-justify mt-0 mb-0 px-0 py-0" style={{ fontSize: "0.8em" }}>
                  {user.status === 'Offline' ? '\u26AA' : ''}
                  {user.status !== 'Offline' && raceEdition.currentSector - user.lastSectorActive < 3 ? '\uD83D\uDFE2' : ''}
                  {user.status !== 'Offline' && raceEdition.currentSector - user.lastSectorActive >= 3 && raceEdition.currentSector - user.lastSectorActive < 15 ? '\uD83D\uDFE1' : ''}
                  {user.status !== 'Offline' && raceEdition.currentSector - user.lastSectorActive >= 15 ? '\uD83D\uDD34' : ''}                  
                  {' ' + user.teamName + 
                  (user.teamName !== user.userName ? ' (' + user.userAcronym + ')' : '') + 
                  (user.controllingUserName && user.userName !== user.controllingUserName ? ' via ' + user.controllingUserAcronym : '')}
                  {user.status !== 'Offline' && user.lastSectorActive <= raceEdition.currentSector - 3 ? 
                      ' (' + (raceEdition.currentSector - user.lastSectorActive) + (user.lastSectorOnline >= raceEdition.currentSector - 2 ? '*' : '') + ')' 
                      : 
                      ''
                  }
                  </p>
              )}
              <br></br>
              <h6>Visitors ({raceEdition.onlineStatus.filter(user => user.role === 'Visitor').length})</h6>
              {raceEdition.onlineStatus
                .filter(user => user.role === 'Visitor')
                .map(user => ({ ...user, timeDifference: getTimeSinceServertime(user.lastTimeActive) }))
                .filter(user => user.timeDifference < 30 * 60)
                .map(user => 
                <p  className="text-justify mt-0 mb-0 px-0 py-0" style={{ fontSize: "0.8em" }}>
                  {user.userName + (user.controllingUserName && user.userName !== user.controllingUserName ? ' (' + user.controllingUserName + ')' : '')}
                  {' - '}
                  {Math.floor(user.timeDifference / 60) + ' minutes ago'}
                  </p>
              )}
            </div>
            <div className="col-lg-8 border border-secondary ml-1 mr-0" style={{ minWidth: 400, maxWidth: "80vw", backgroundColor: 'rgba(255, 255, 255, 1)' }}>

              <C4FChat type="race"
                mode={['Participant', 'Admin', 'FairplayCommittee', 'Mentor'].includes(props.userRole) ? 'readwrite' : 'readonly'}
                chat={props.raceEditionId} 
                user={props.userName} 
                role={['Admin', 'FairplayCommittee', 'Mentor'].includes(props.userRole) ? props.userRole : null}
                refresh={chatRefresh} height={288}
                setOnline={() => setOnlineStatus('Active')} />
            </div>
          </div>

          {(() => {
            if (props.userRole !== 'Participant' || raceEdition.sprintStatus === 'Completed')
              return <div className="row d-flex my-2 justify-content-center">
                <div className="col border border-secondary m-0" style={{ minWidth: 400, maxWidth: "80vw", backgroundColor: 'rgba(255, 255, 255, 1)' }}>
                  <C4FChat type="visitor" chat={props.raceEditionId} user={props.userName} refresh={chatRefresh} height={288} setOnline={() => setOnlineStatus('Active')} />
                </div>
              </div>
          })()}
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </Col>
      </Row >
    </div >
  };
}

export default Race;
